import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form, Modal, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import $, { data } from 'jquery';
import '../../mcss/common.css';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign, faFileDownload, faEye, faMoneyCheck } from '@fortawesome/free-solid-svg-icons';

import { faUniversity } from '@fortawesome/free-solid-svg-icons';
import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';
import InwardCover from './InwardCover';
import InwardCreditReceived from './InwardCreditReceived';
import * as Picklist from "../Picklist";
import AsyncSelect from 'react-select/async';
import Master_individual_profile from '../master/Master_individual_profile';

function InwardList() {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [rightInwardList, setRightInwardList] = useState([]);
    const [rightDownloadBankFile, setRightDownloadBankFile] = useState([]);
    const [entityType, setEntityType] = useState(sessionStorage.entityType);
    const [modalRef, setModalRef] = useState("");

    const [rightInwardRefundApprove, setRightInwardRefundApprove] = useState([]);
    const [rightInwardRefundApproveBm, setRightInwardRefundApproveBm] = useState([]);
    const [rightInwardRefundApproveAccount, setRightInwardRefundApproveAccount] = useState([]);
    const [rightInwardRefundExecute, setRightInwardRefundExecute] = useState([]);
    const [rightInwardCoverFinal, setRightInwardCoverFinal] = useState([]);
    const [rightInwardCreditReceived, setRightInwardCreditReceived] = useState([]);
    const [rightInwardReturnToBank, setRightInwardReturnToBank] = useState([]);



    const [newBranchProcess, setNewBranchProcess] = useState(true);

    //////////////////////////////

    const [acceptDeclaration, setAcceptDeclaration] = useState(false);
    const [showUnlockTran, setShowUnlockTran] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const [showNewWindow, setShowNewWindow] = useState(false);
    const [showCvr, setShowCvr] = useState(false);
    const [showInwardCredit, setShowInwardCredit] = useState(false);

    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);


    // Inward search list
    const [srchSrno, setSrchSrno] = useState("");
    const [srchStatus, setSrchStatus] = useState("ALL");
    const [ddReqStatusOptions, setDdReqStatusOptions] = useState([]);

    const [srchIssuer, setSrchIssuer] = useState(0);
    const [ddSrchIssuer, setDdSrchIssuer] = useState([]);
    const [srchToDate, setSrchToDate] = useState(new Date());
    const [srchFromDate, setSrchFromDate] = useState(new Date());

    const [srchBran, setSrchBran] = useState("0");
    const [ddSrchBranOptions, setDdSrchBranOptions] = useState([]);
    const [srchBranSelect, setSrchBranSelect] = useState([]);

    const [tranListData, setTranListData] = useState([]);

    // Inward entry form
    const [reqHeader, setReqHeader] = useState([]);
    const [reqSrno, setReqSrno] = useState(0);
    const [reqStatus, setReqStatus] = useState("");
    const [reqStatusName, setReqStatusName] = useState("");

    const [reqIssuer, setReqIssuer] = useState("0");
    const [reqIsd, setReqIsd] = useState("0");
    const [ddReqIsdOptions, setDdReqIsdOptions] = useState([]);
    const [reqIsdSelect, setReqIsdSelect] = useState([]);

    const [reqBran, setReqBran] = useState("0");
    const [ddReqBranOptions, setDdReqBranOptions] = useState([]);
    const [reqBranSelect, setReqBranSelect] = useState([]);

    const [reqBranName, setReqBranName] = useState("");

    const [reqQuantity, setReqQuantity] = useState("");
    const [reqInwardRef, setReqInwardRef] = useState("");
    const [reqDate, setReqDate] = useState(new Date());
    const [reqZenithRef, setReqZenithRef] = useState("");

    const [reqIssuerComment, setReqIssuerComment] = useState("");

    const [reqAdditionalComment, setReqAdditionalComment] = useState("");

    const [reqConfirmCode, setReqConfirmCode] = useState("0");
    const [reqConfirmComment, setReqConfirmComment] = useState("");
    const [reqConfirmQuantity, setReqConfirmQuantity] = useState("");

    const [reqClientBank, setReqClientBank] = useState("0");
    const [ddReqClientBankOptions, setDdReqClientBankOptions] = useState([]);
    const [reqClientBankSelect, setReqClientBankSelect] = useState([]);


    const [reqClientAcctNo, setReqClientAcctNo] = useState("");
    const [reqClientAcctIfsc, setReqClientAcctIfsc] = useState("");
    const [reqClientRate, setReqClientRate] = useState(0);
    const [reqClientGst, setReqClientGst] = useState(0);
    const [reqClientOthCharges, setReqClientOthCharges] = useState(0);
    const [reqClientRefundInr, setReqClientRefundInr] = useState(0);
    const [reqTaxableValue, setReqTaxableValue] = useState(0);
    const [reqRoundOff, setReqRoundOff] = useState(0);


    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);
    const [reqAgentSelect, setReqAgentSelect] = useState([]);
    const [reqAgentCommission, setReqAgentCommission] = useState("");

    const [reqReprocessedDate, setReqReprocessedDate] = useState(new Date());
    const [reqReprocessedDateDmy, setReqReprocessedDateDmy] = useState("");

    const [reqRefundApprovedZm, setReqRefundApprovedZm] = useState(0);
    const [reqRefundApprovedAccount, setReqRefundApprovedAccount] = useState(0);
    const [reqRefundApproved, setReqRefundApproved] = useState(0);
    const [reqRefundDate, setReqRefundDate] = useState(new Date());
    const [reqRefundDateDmy, setReqRefundDateDmy] = useState("");

    const [reqPayBankCode, setReqBankCode] = useState("0");
    const [ddReqPayBankOptions, setDdReqPayBankOptions] = useState([]);

    const [reqPayBankRef, setReqPayBankRef] = useState("");
    const [reqPayRefundedAmount, setReqPayRefundedAmount] = useState("");
    const [reqPayBankName, setReqPayBankName] = useState("");
    const [reqRefundExecuted, setReqRefundExecuted] = useState("0");
    const [reqDocRemark, setReqDocRemark] = useState("");

    const [remark, setRemark] = useState([]);
    const [logListData, setLogListData] = useState([]);
    const [commentListData, setCommentListData] = useState([]);
    const [coverListData, setCoverListData] = useState([]);
    const [docListData, setDocListData] = useState([]);

    const [editBankDetailsAndRate, setEditBankDetailsAndRate] = useState(false);

    const [srchAutoRefresh, setSrchAutoRefresh] = useState(false);

    const [reqPaymentCredited, setReqPaymentCredited] = useState("0");

    const [reqEditAd2References, setReqEditAd2References] = useState(false);

    const [disableSave, setDisableSave] = useState(false);
    const [reqSubjectLine, setReqSubjectLine] = useState("");
    const [reqRemitterName, setReqRemitterName] = useState("");
    const [reqBookingVoucher, setReqBookingVoucher] = useState("");
    const [reqBankDetailsConfirm, setReqBankDetailsConfirm] = useState("0");
    const [isNewOutwordTT, setIsNewOutwordTT] = useState(false);
    const [newOutwordRefNo, setNewOutwordRefNo] = useState("");
    const [reqClientBankNameOther, setReqClientBankNameOther] = useState("");
    const [reqAgentNameOther, setReqAgentNameOther] = useState("");
    const [executeRefundAgain, setExecuteRefundAgain] = useState(false);

    const [fxTranNo, setFxTranNo] = useState("");
    const [backOfficeData, setBackOfficeData] = useState([]);
    const [showFetchTransaction, setShowFetchTransaction] = useState(false);
    const [ftCalcSrvChrg, setFtCalcSrvChrg] = useState(0);
    const [ftCalcGst, setFtCalcGst] = useState(0);
    const [ftCalcRoundOff, setFtCalcRoundOff] = useState(0);
    const [ftOrderDate, setFtOrderDate] = useState("");


    const [reqRemitterType, setReqRemitterType] = useState("I");
    const [pickedCorporate, setPickedCorporate] = useState(null);
    const [pickedIndividual, setPickedIndividual] = useState(null);
    const [showIndividualForm, setShowIndividualForm] = useState(false);
    const [scrIndividual, setScrIndividual] = useState("");

    const [reqIgstInr, setReqIgstInr] = useState(0);
    const [reqSgstInr, setReqSgstInr] = useState(0);
    const [reqCgstInr, setReqCgstInr] = useState(0);
    const [reqUgstInr, setReqUgstInr] = useState(0);
    const [reqGstInr, setReqGstInr] = useState(0);
    const [pickedExecutive, setPickedExecutive] = useState(null);
    const [pickedSubExecutive, setPickedSubExecutive] = useState(null);
    const [agentGroupCode, setAgentGroupCode] = useState(0);
    const [agentAccountCode, setAgentAccountCode] = useState(0);

    const [showRefundConfirmModal, setShowRefundConfirmModal] = useState(false);
    const [allChecked, setAllChecked] = useState(false);
    const [tpBankData, setTPBankData] = useState([]);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [filterBankName, setFilterBankName] = useState("AXIS")
    const [reqGSTTaxable, setReqGSTTaxable] = useState(0);
    ;

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'INWARDLIST'], function (result) {
                let resp = JSON.parse(result);
                setRightInwardList(resp);
                Common.callApi(Common.apiRight, [sid, 'all', 'DOWNLOAD_BANKFILE'], function (result) {
                    let resp = JSON.parse(result);
                    setRightDownloadBankFile(resp);
                })

                if (resp.query === "1") {
                    //                             { "value": "ACQ", "name": "Add Cover Quick" },
                    setDdReqStatusOptions(
                        [
                            { "value": "ALL", "name": "ALL" },
                            { "value": "CLS", "name": "Closed" },
                            { "value": "OPN", "name": "Open" },
                            { "value": "NEW", "name": "New" },
                            { "value": "PRE", "name": "Pending Reprocess" },
                            { "value": "REP", "name": "Reprocessed" },
                            { "value": "PBC", "name": "Waiting for Branch Confirmation" },
                            { "value": "PFC", "name": "Pending Fund Credit Confirmation" },
                            { "value": "CRF", "name": "Credit Received not Requested Refund" },
                            { "value": "PBT", "name": "Pending Refund Approval By Accounts" },
                            { "value": "PCR", "name": "Pending Refund Approval By Accounts Credit Received and Refund Requested" },
                            { "value": "RAA", "name": "Refund Approved By Accounts" },
                            { "value": "RFA", "name": "Refund Approved By ZM" },
                            { "value": "REF", "name": "Refund Processed" },
                            { "value": "NTT", "name": "New Outword TT" },
                            { "value": "ACV", "name": "Add Cover Confirmed Refund" },
                            { "value": "ACA", "name": "Add Cover All" }
                        ]
                    );
                    Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                        setDdSrchIssuer(JSON.parse(result));
                    });
                    Common.callApi(Common.apiIsd, [sid, 'ddlistjsonselect'], function (result) {
                        setDdReqIsdOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiUser, [sid, 'branchallowedselect'], function (result) {
                        let resp = JSON.parse(result);
                        setDdReqBranOptions(resp);
                        setDdSrchBranOptions(resp);
                    });
                    Common.callApi(Common.apiBank, [sid, 'banklistall'], function (result) {
                        let resp = JSON.parse(result);
                        setDdReqClientBankOptions(resp);
                    });
                    // Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentselect'], function (result) {
                    //     setDdReqAgentOptions(JSON.parse(result));
                    // });
                    // Refund approve zm
                    Common.callApi(Common.apiRight, [sid, 'all', 'INWARDREFUNDAPPROVE'], function (result) {
                        setRightInwardRefundApprove(JSON.parse(result));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'INWARDREFUNDAPPROVEBM'], function (result) {
                        setRightInwardRefundApproveBm(JSON.parse(result));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'INWARDREFUNDAPPROVEACCOUNT'], function (result) {
                        setRightInwardRefundApproveAccount(JSON.parse(result));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'INWARDREFUNDEXECUTE'], function (result) {
                        setRightInwardRefundExecute(JSON.parse(result));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'INWARDCOVERFINAL'], function (result) {
                        setRightInwardCoverFinal(JSON.parse(result));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'INWARDCREDITRECEIVED'], function (result) {
                        setRightInwardCreditReceived(JSON.parse(result));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'INWARDRETURNTOBANK'], function (result) {
                        setRightInwardReturnToBank(JSON.parse(result));
                    });
                    Common.callApi(Common.apiBank, [sid, 'ddlistjson'], function (result3) {
                        setDdReqPayBankOptions(JSON.parse(result3));
                    });
                } else {
                    navigate('/'); // no query right
                }
            });

            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    useEffect(() => {
        if (!Common.showPickList) return;
        if (reqQuantity > 0 && reqClientRate > 0 && reqBran && reqRemitterType) {
            const obj = {
                reqSellRate: reqClientRate,
                reqQuantity: reqQuantity,
                reqPurpose: '',
                loan: "",
                reqPan: "",
                reqRemitterType: reqRemitterType,
                pickedCorporate: reqRemitterType === "C" ? null : pickedCorporate,
                reqBranch: reqBran,
                reqBankChargesInr: reqClientOthCharges * 1 || 0,
                reqNostroChargesInr: 0
            }
            Common.callApi(Common.apiInProgress, [sid, "getcharges", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                setReqIgstInr(resp.igst);
                setReqCgstInr(resp.sgst);
                setReqSgstInr(resp.sgst);
                setReqUgstInr(resp.ugst);//gstTaxable
                setReqGSTTaxable(resp.gstTaxable);
                setReqClientGst(resp.igst * 1 + resp.sgst * 1 + resp.cgst * 1 + resp.ugst * 1);
                setReqGstInr(resp.igst + resp.sgst + resp.cgst + resp.ugst);

                // setForexAmount(resp.forex);
                setReqClientRefundInr(resp.totalinrPP);
                setReqRoundOff(resp.roundoffPP);
            });
        }
    }, [reqQuantity, reqClientRate, reqBran, reqRemitterType, pickedCorporate, reqClientOthCharges, sid]);

    function allowNewAdd() {
        return rightInwardList.add === "1" && reqSrno === 0;
    }

    function handleReqAgentOptions(v) {
        setReqAgentSelect(v);
        let a = v?.id?.split("^");
        // console.log(a);
        setReqAgent(a[1]);
        setAgentGroupCode(a[2]);
        setAgentAccountCode(a[3]);

    }

    function handleReqBranchOptions(v) {
        setReqBranSelect(v);
        setReqBran(v.value);

    }

    function handleSrchBranchOptions(v) {
        setSrchBranSelect(v);
        setSrchBran(v.value);
    }

    function handleReqIsdOptions(v) {
        setReqIsdSelect(v);
        setReqIsd(v.value);
    }

    function handleReqClientBankOptions(v) {
        setReqClientBankSelect(v);
        setReqClientBank(v.value);
    }

    function backToList() {
        setShowNewWindow(false);
        setShowCvr(false);
        setShowInwardCredit(false);
        setShowFilter(true);
        searchRequest(1);
    }

    /*
        function getStatusName(v) {
            switch (v) {
                case 'NEW':
                    return 'NEW';
                case 'PBC':
                    return 'Waiting for Branch Confirmation : PBC';
                case 'PBT':
                    return 'Pending Bank Transfer :PBT';
                case 'PRE':
                    return 'Pending Reprocess : PRE';
                case 'REP':
                    return 'Reprocessed : REP';
                case 'RFA':
                    return 'Refund Approved By ZM : RFA';
                case 'REF':
                    return 'Refund Processed : REF';
                case 'RAA':
                    return 'Refund Approved by Accounts : RAA'
                case "NTT":
                    return "New Outword TT";
                default:
                    return '';
            }
        }
    */
    function getStatusNameByRow(res) {
        var result = "";

        if (res.reqi_status === "NEW") {
            result = "NEW";
        } else if (res.reqi_status === "NTT") {
            result = "New Outword TT";
        } else if (res.reqi_status === "REP") {
            result = "Reprocessed";
        } else if (res.reqi_status === "RTT") {
            result = "Returned to Bank";
        } else if (res.reqi_status === "PBC" && res.reqi_branchconfirmstatus === "0") {
            result = "Waiting for Branch Confirmation";
        } else if (res.reqi_status === "PRE" && res.reqi_branchconfirmstatus === "PRE") {
            result = "Pending Reprocess";
        } else if (res.reqi_branchconfirmstatus === "PBT" && res.reqi_declaration === "1" && res.reqi_bankdetailsconfirm === "0") {
            result = "Confirmed by Branch";
        } else if (res.reqi_branchconfirmstatus === "PBT" && res.reqi_declaration === "1" && res.reqi_bankdetailsconfirm === "1" && res.reqi_refundapprovedaccounts === "0") {
            result = "Pending Account Approval"; // refund requested by branch.
        } else if (res.reqi_branchconfirmstatus === "PBT" && res.reqi_declaration === "1" && res.reqi_bankdetailsconfirm === "1" && res.reqi_refundapprovedaccounts === "1" && res.reqi_refundapprovedzm === "0") {
            result = "Pending ZM Approval";
        } else if (res.reqi_branchconfirmstatus === "PBT" && res.reqi_declaration === "1" && res.reqi_bankdetailsconfirm === "1" && res.reqi_refundapprovedaccounts === "1" && res.reqi_refundapprovedzm === "1" && res.reqi_refundexecuted === "0") {
            result = "Pending Bank Transfer";
        } else if (res.reqi_branchconfirmstatus === "PBT" && res.reqi_declaration === "1" && res.reqi_bankdetailsconfirm === "1" && res.reqi_refundapprovedaccounts === "1" && res.reqi_refundapprovedzm === "1" && res.reqi_refundexecuted === "1") {
            result = "Refund Processed";
        }
        return result;
    }

    function getActionName(v) {
        switch (v) {
            case "PRE":
                return "Reprocess";
            case "PBT":
                return "Refund";
            case "NTT":
                return "New Outword TT";
            default:
                return "";
        }
    }

    function resetForm() {
        setReqQuantity("");
        setReqInwardRef("")
        setReqDate(new Date());
        setReqZenithRef("");
        setReqIsd("0");
        setReqIsdSelect({ label: 'Select', value: '0' });
        setReqBran("0");
        setReqBranSelect({ label: 'Select', value: '0' });
        setReqIssuerComment("");
        setReqAdditionalComment("");
        setReqIssuer("0");
        setReqSrno(0);
        setReqStatus("NEW");
        setReqStatusName("NEW");
        setLogListData([]);
        setCommentListData([]);
        setCoverListData([]);
        setDocListData([]);
        setReqHeader([]);
        setReqRefundExecuted("0");
        setRemark("");
        ////////////////////////////////
        setReqBranName("");
        setReqConfirmCode("0");
        setReqConfirmComment("");
        setReqClientBank("0");
        setReqClientAcctNo("");
        setReqClientAcctIfsc("");
        setReqClientRate("");
        setReqClientGst("");
        setReqClientOthCharges("");
        setReqRoundOff("");
        setReqClientRefundInr("");
        setReqAgent("0");
        setReqAgentCommission("");
        setReqReprocessedDate(new Date());
        setReqReprocessedDateDmy("");
        setReqRefundApproved("0");
        setReqRefundApprovedZm("0");
        setReqRefundApprovedAccount("0");
        setReqRefundDate(new Date());
        setReqRefundDateDmy("");
        setReqBankCode("0");
        setReqPayBankRef("");
        setReqPayRefundedAmount("");
        setReqPayBankName("");
        setReqPaymentCredited("0");
        setAcceptDeclaration(false);
        setEditBankDetailsAndRate(false);
        setReqSubjectLine("");
        setReqRemitterName("");
        setReqBookingVoucher("");
        setReqConfirmQuantity("");
        setReqClientBankNameOther("");
        setReqAgentNameOther("");
        setExecuteRefundAgain(false);
        setFxTranNo("");
        setRefreshCounter(refreshCounter + 1);

        setReqRemitterType("I");
        setPickedCorporate(null);
        setPickedIndividual(null);
    }

    function addNewInward() {
        setDisableSave(false);
        setShowCvr(false);
        setShowFilter(false);
        resetForm();
        setShowNewWindow(true);
    }

    function searchRequest(v) {
        if (showFilter || v === 1) {
            var object1 = {
                srchSrno: srchSrno,
                srchStatus: srchStatus,
                srchIssuer: srchIssuer,
                srchFromDate: Common.dateYMD(srchFromDate),
                srchToDate: Common.dateYMD(srchToDate),
                srchBran: srchBran
            }
            Common.callApi(Common.apiInward, [sid, 'listjson', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.status === "MSG0002") {
                    navigate('/');
                }
                $('.loader').hide();
                setTranListData(resp);
                setRefreshCounter(refreshCounter + 1);
                Common.setPageTitle(resp.length);
            });
        }
    }

    function saveNewInward(tempStatus) {
        setDisableSave(true);
        $('.loader').show();
        var isOk = 0;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        // || reqInwardRef.trim() === "" || reqZenithRef.trim() === ""
        if (reqIssuer === "0" || reqDate === null || reqIsd === "0" || reqQuantity === "" || reqIssuerComment.trim() === "") {
            msg[i++] = (reqIssuer === "0" ? " Issuer " : '');
            msg[i++] = (reqDate === null ? " Date " : '');
            msg[i++] = (reqIsd === "0" ? " ISD " : '');
            msg[i++] = (reqQuantity === "" ? " Quantity " : '');
            // msg[i++] = (reqInwardRef.trim() === "" ? " Inward Reference " : '');
            //  msg[i++] = (reqZenithRef.trim() === "" ? " Zenith Reference " : '');
            msg[i++] = (reqIssuerComment.trim() === "" ? " Issuer Comment " : '');
            isOk = 1;
        }

        if (isOk === 0) {
            var object1 = {
                reqBran: reqBran,
                reqDate: Common.dateYMD(reqDate),
                reqIsd: reqIsd,
                reqQuantity: reqQuantity,
                reqInwardRef: reqInwardRef,
                reqZenithRef: reqZenithRef,
                reqIssuerComment: reqIssuerComment,
                reqAdditionalComment: reqAdditionalComment,
                reqSubjectLine: reqSubjectLine,
                reqIssuer: reqIssuer,
                reqStatus: tempStatus,
                reqRemitterName: reqRemitterName
            }
            Common.callApi(Common.apiInward, [sid, 'addNew', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                setDisableSave(false);
                $('.loader').hide();
                if (resp.err === "") {
                    resetForm();
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    backToList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        } else {
            setDisableSave(false);
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }

    function showInwardDetails(srno) {
        Common.callApi(Common.apiInward, [sid, 'getdetail', srno], function (result) {
            let resp = JSON.parse(result);

            if (resp.status === "MSG0002") {
                navigate('/');
            }
            $('.loader').hide();
            setShowFilter(false);
            setShowNewWindow(true);
            loadInwardDetail(resp);

            setRefreshCounter(refreshCounter + 1);
        });
    }

    function loadInwardDetail(resp) {
        setShowUnlockTran(false);
        setReqHeader(resp.data[0]);
        setReqSrno(resp.data[0].reqi_srno);
        setReqQuantity(resp.data[0].reqi_quantity);
        setReqInwardRef(resp.data[0].reqi_inwardrefno)

        var rdate = (resp.data[0].reqi_date).split("-");
        setReqDate((new Date()).setFullYear(rdate[0], rdate[1] - 1, rdate[2]));

        setReqZenithRef(resp.data[0].reqi_zenithrefno);
        setReqIsd(resp.data[0].reqi_isd);
        setReqIsdSelect({ value: resp.data[0].reqi_isd, label: resp.data[0].reqi_isd + " " + resp.data[0].isd_name });
        setReqBran(resp.data[0].reqi_brnno);
        setReqBranSelect({ value: resp.data[0].reqi_brnno, label: resp.data[0].reqi_branchname });

        setReqBranName(resp.data[0].reqi_branchname);
        setReqIssuerComment(resp.data[0].reqi_issuercomment);
        setReqAdditionalComment(resp.data[0].reqi_additionalcomment);
        setReqIssuer(resp.data[0].reqi_issuer);
        setReqStatus(resp.data[0].reqi_status);

        // setReqStatusName(getStatusName(resp.data[0].reqi_status));
        setReqStatusName(getStatusNameByRow(resp.data[0]));

        setLogListData(resp.log);
        setCommentListData(resp.comm);
        setCoverListData(resp.cover);
        setDocListData(resp.doc);

        setReqConfirmCode(resp.data[0].reqi_branchconfirmstatus);
        setReqConfirmComment(resp.data[0].reqi_branchconfirmremark);
        setReqClientBank(resp.data[0].reqi_clientbank);
        setReqClientAcctNo(resp.data[0].reqi_clientbankacctno);
        setReqClientAcctIfsc(resp.data[0].reqi_clientbankacctifsc);
        setReqClientRate(resp.data[0].reqi_clientrate);

        setReqClientGst(resp.data[0].reqi_clientgst);
        setReqClientOthCharges(resp.data[0].reqi_clientothcharges);
        setReqRoundOff(resp.data[0].reqi_clientroundoff);
        setReqClientRefundInr(resp.data[0].reqi_clientrefundinr);
        setReqClientBankSelect({ value: resp.data[0].reqi_clientbank, label: resp.data[0].mbl_name });
        setReqAgent(resp.data[0].reqi_agentno);
        if (resp.data[0].reqi_agentno) {
            setReqAgentSelect({
                id: '^' + (resp.data[0].reqi_agentno || 0) + '^' + (resp.data[0].reqi_agent_group_code || 0) + '^' + (resp.data[0].reqi_agent_account_code || 0) + '^' + (resp.data[0].reqi_agentname || '') + '^',
                label: ' ' + (resp.data[0].reqi_agentno || '') + ' ' + (resp.data[0].reqi_agent_group_code || ' ') + ' ' + (resp.data[0].reqi_agent_account_code || '') + ' ' + (resp.data[0].reqi_agentname || '') + ' '
            });
        } else {
            setReqAgentSelect('');
        }
        setReqAgentCommission(resp.data[0].reqi_agentcommission);

        if (resp.data[0].reqi_reprocesseddate !== null) {
            var rdate = (resp.data[0].reqi_reprocesseddate).split("-");
            setReqReprocessedDate((new Date()).setFullYear(rdate[0], rdate[1] - 1, rdate[2]));
        }



        setReqReprocessedDateDmy(resp.data[0].reqi_reprocesseddatedmy);
        setReqRefundApproved(resp.data[0].reqi_refundapproved);
        setReqRefundApprovedZm(resp.data[0].reqi_refundapprovedzm);
        setReqRefundApprovedAccount(resp.data[0].reqi_refundapprovedaccounts);


        if (resp.data[0].reqi_refundexecuted * 1 === 1 && resp.data[0].reqi_status === "REF") {
            if (resp.data[0].reqi_refundeddate !== null) {
                var rdate = (resp.data[0].reqi_refundeddate).split("-");
                setReqRefundDate((new Date()).setFullYear(rdate[0], rdate[1] - 1, rdate[2]));
            }
            setReqRefundDateDmy(resp.data[0].reqi_refundeddatedmy);
        }

        setReqBankCode(resp.data[0].reqi_refundedbankcode);
        setReqPayBankRef(resp.data[0].reqi_refundedbankref);
        setReqPayRefundedAmount(resp.data[0].reqi_refundedamount);
        setReqPayBankName(resp.data[0].refund_bank_name);
        setReqRefundExecuted(resp.data[0].reqi_refundexecuted);
        setReqPaymentCredited(resp.data[0].reqi_paymentcredited);

        setAcceptDeclaration((resp.data[0].reqi_declaration === "1" ? true : false));
        setEditBankDetailsAndRate(false);
        setReqSubjectLine(resp.data[0].reqi_subjectline);
        setReqRemitterName(resp.data[0].reqi_remittername);
        setReqBookingVoucher(resp.data[0].reqi_bookingvoucher);
        setReqBankDetailsConfirm(resp.data[0].reqi_bankdetailsconfirm);
        setReqConfirmQuantity(resp.data[0].reqi_branchreprocessquantity);
        setReqClientBankNameOther(resp.data[0].reqi_otherbankname);
        setReqAgentNameOther(resp.data[0].reqi_otheragentname);

        if (resp.data[0].reqi_newoutwardtt === "1") {
            setIsNewOutwordTT(true);
        } else {
            setIsNewOutwordTT(false);
        }

        setNewOutwordRefNo(resp.data[0].reqi_newoutwardrefno);
        setExecuteRefundAgain(false);
        setRefreshCounter(refreshCounter + 1);
        if (resp.individual == "") setPickedIndividual(null);
        else setPickedIndividual(JSON.parse(resp.individual));

        if (resp.party == "") setPickedCorporate(null);
        else setPickedCorporate(JSON.parse(resp.party));

        setReqCgstInr(resp.data[0].reqi_cgst);
        setReqSgstInr(resp.data[0].reqi_sgst);
        setReqIgstInr(resp.data[0].reqi_igst);
        setReqUgstInr(resp.data[0].reqi_ugst);
        if (resp?.executive?.length > 0) {
            setPickedExecutive({ id: resp.executive[0], label: resp.executive[1] })
        } else {
            setPickedExecutive(null)
        }
        if (resp?.subExecutive?.length > 0) {
            setPickedSubExecutive({ id: resp.subExecutive[0], label: resp.subExecutive[1] })
        } else {
            setPickedSubExecutive(null)
        }
        setAgentGroupCode(resp.data[0].reqi_agent_group_code);
        setAgentAccountCode(resp.data[0].reqi_agent_account_code);

        if (resp.data[0].reqi_clienttype != null) setReqRemitterType(resp.data[0].reqi_clienttype);
    }

    function sendInwardToBranch() {
        $('.loader').show();
        if (reqBran * 1 > 0) {
            var object1 = {
                reqSrno: reqSrno,
                reqBran: reqBran
            }
            Common.callApi(Common.apiInward, [sid, 'referbranch', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.status === "MSG0002") {
                    navigate('/');
                }
                $('.loader').hide();
                if (resp.err === "") {
                    resetForm();
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    backToList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                setRefreshCounter(refreshCounter + 1);

            });

        } else {
            $('.loader').hide();
            setMsgText("Please select branch.");
            setMsgBox(true);
        }
    }

    function btnAddComment() {
        $('.loader').show();
        var object1 = {
            srno: reqSrno,
            cmnt: remark
        }
        Common.callApi(Common.apiInward, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.err === "") {
                setRemark("");
                setCommentListData(resp.comm);
                setLogListData(resp.log);
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function submitBranchResponse(declarationCheck) {
        $('.loader').show();
        var isOk = true;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");

        if (reqConfirmCode === "0") {
            isOk = false;
            msg[i++] = (reqConfirmCode === "0" ? " Confirm refund or reprocess." : '');
        }
        if (declarationCheck) {
            if (!acceptDeclaration) {
                isOk = false;
                msg[i++] = "Acceptance of Declaration is must. ";
            }
        } else {
            /*
                if (reqConfirmCode === "PBT" && (reqClientBank === "0" || reqClientAcctNo.trim() === "" || reqClientAcctIfsc.trim() === ""
                || reqClientRate === "" || reqClientRate === "0")) {
                    isOk = false;
                    msg[i++] = (reqClientBank === "0" ? " Bank " : '');
                    msg[i++] = (reqClientAcctNo.trim() === "" ? " Account Number " : '');
                    msg[i++] = (reqClientAcctIfsc.trim() === "" ? " IFSC " : '');
                    msg[i++] = (reqClientRate === "" ? " Rate " : '');
                    msg[i++] = (reqClientRate === "0" ? " Rate " : '');
                }
            */

        }

        if (reqConfirmCode === "PRE" && (reqConfirmComment.trim() === "" || reqConfirmQuantity.trim() === "")) {
            isOk = false;
            msg[i++] = (reqConfirmComment.trim() === "" ? " Confirmation Statement" : '');
            msg[i++] = (reqConfirmQuantity.trim() === "" ? " Reprocess Quantity" : '');
        }

        if (isOk) {
            var object1 = {
                reqSrno: reqSrno,
                reqQuantity: reqQuantity,
                reqConfirmCode: reqConfirmCode,
                reqConfirmComment: reqConfirmComment,
                reqClientBank: reqClientBank,
                reqClientAcctNo: reqClientAcctNo,
                reqClientAcctIfsc: reqClientAcctIfsc,
                reqClientRate: (reqClientRate === "" ? 0 : reqClientRate),
                reqClientGst: (reqClientGst === "" ? 0 : reqClientGst),
                reqClientOthCharges: (reqClientOthCharges === "" ? 0 : reqClientOthCharges),
                reqClientRefundInr: reqClientRefundInr,
                reqAgent: reqAgent,
                reqAgentCommission: reqAgentCommission,
                reqConfirmQuantity: (reqConfirmQuantity === "" ? 0 : reqConfirmQuantity),
                acceptDeclaration: (acceptDeclaration ? 1 : 0),
                reqRemitterName: reqRemitterName,
                isNewOutwordTT: (isNewOutwordTT ? 1 : 0),
                newOutwordRefNo: newOutwordRefNo
            }
            Common.callApi(Common.apiInward, [sid, 'branchresponse', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    backToList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                setRefreshCounter(refreshCounter + 1);
            });
        } else {
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }

    function submitReprocessed() {
        $('.loader').show();
        var isOk = true;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");

        if (reqReprocessedDate === null) {
            isOk = false;
            msg[i++] = (reqReprocessedDate === null ? " Reprocess Date " : '');
        }

        if (isOk) {
            var object1 = {
                reqSrno: reqSrno,
                reqReprocessedDate: Common.dateYMD(reqReprocessedDate)
            }
            Common.callApi(Common.apiInward, [sid, 'setreprocessed', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    backToList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        } else {
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }

    function clickApproveRefund() {
        $('.loader').show();
        var object1 = {
            reqSrno: reqSrno
        }
        Common.callApi(Common.apiInward, [sid, 'approverefund', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                backToList();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function clickApproveRefundBm() {
        $('.loader').show();
        var object1 = {
            reqSrno: reqSrno
        }
        Common.callApi(Common.apiInward, [sid, 'approverefundbm', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                backToList();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function clickRefundExecuted() {
        $('.loader').show();
        // console.log(reqRefundDate);
        var isOk = true;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        if (reqRefundDate === null || reqPayBankCode * 1 === 0 || reqPayBankRef.trim() === "" || reqPayRefundedAmount.trim() === "" || reqPayRefundedAmount * 1 < 1) {
            isOk = false;
            msg[i++] = (reqRefundDate === null ? " Date " : '');
            msg[i++] = (reqPayBankCode * 1 === 0 ? " Bank " : '');
            msg[i++] = (reqPayBankRef.trim() === "" ? " Refrence Number " : '');
            msg[i++] = (reqPayRefundedAmount.trim() ? " Amount " : '');
            msg[i++] = (reqPayRefundedAmount * 1 < 1 === null ? " Amount " : '');
        }
        if (isOk) {
            var object1 = {
                reqSrno: reqSrno,
                reqRefundDate: Common.dateYMD(reqRefundDate),
                reqPayBankCode: reqPayBankCode,
                reqPayBankRef: reqPayBankRef,
                reqPayRefundedAmount: reqPayRefundedAmount
            }
            Common.callApi(Common.apiInward, [sid, 'amountrefunded', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    backToList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        } else {
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }

    function clickApproveRefundAccount() {
        $('.loader').show();
        var isOk = true;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");

        if (reqBookingVoucher.trim() === "") {
            isOk = false;
            msg[i++] = "Please fill booking voucher";
        }
        if (isOk) {
            var object1 = {
                reqSrno: reqSrno,
                reqBookingVoucher: reqBookingVoucher
            }
            Common.callApi(Common.apiInward, [sid, 'approverefundaccount', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    backToList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        } else {
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }


    function showCoverWindow(v) {
        setModalRef(v);
        setShowCvr(true);
        setShowFilter(false);
    }

    function showInwardCreditWindow(v) {
        setModalRef(v);
        setShowCvr(false);
        setShowFilter(false);
        setShowInwardCredit(true);
    }

    // quickCoverFinal(res.reqi_srno, res.reqi_branchconfirmstatus, res.reqi_quantity, res.reqi_branchreprocessquantity)
    function quickCoverFinal(srno, branchconfirmstatus, quantity, branchreprocessquantity) {
        $('.loader').show();

        let qty = 0;
        if (branchconfirmstatus === "PBT") {
            qty = quantity;
        }
        if (branchconfirmstatus === "PRE") {
            qty = branchreprocessquantity * 1 - quantity * 1;
        }

        if (parseFloat($('#DealRate' + srno).val()) !== $('#DealRate' + srno).val() * 1) {
            $('.loader').hide();
            setMsgText("Please input valid Deal Rate.");
            setMsgBox(true);
        } else {
            var obj = {
                srno: srno,
                dealId: $('#DealId' + srno).val(),
                dealRate: $('#DealRate' + srno).val(),
                dealTenure: $('#DealTenure' + srno).val(),
                dealQty: qty
            }
            Common.callApi(Common.apiInward, [sid, 'quickcoverfinal', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    $('.loader').hide();
                    setRefreshCounter(refreshCounter + 1);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    searchRequest(0);
                } else {
                    $('.loader').hide();
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function onChangeSrchStatus(v) {
        setTranListData([]);
        setSrchStatus(v);
    }

    function unlockTransaction() {
        $('.loader').show();
        var object1 = {
            reqSrno: reqSrno
        }
        Common.callApi(Common.apiInward, [sid, 'unlocktransaction', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                backToList();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }
    function handleShowUnlockTran() {
        setShowUnlockTran(!showUnlockTran);
    }

    function handleAcceptDeclaration() {
        setAcceptDeclaration(!acceptDeclaration);
    }

    function btnUploadFile() {
        $('.loader').show();

        if (document.getElementById('fileToUpload').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');

            if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0] === undefined) {

            } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else {
                var object1 = {
                    sid: sid,
                    uploadType: 'INWARD',
                    srno: reqSrno,
                    pageright: 'INWARDLIST',
                    docid: "0",
                    remark: reqDocRemark
                }
                Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                    let resp = JSON.parse(result);
                    $('.loader').hide();
                    if (resp.error === "") {
                        setDocListData(resp.docdetail);
                        alert(resp.message);

                        setReqDocRemark("");
                    }
                });
            }
        }
    }


    function btnDocumentView(srno, filename) {
        $('.loader').show();
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInward, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }
    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInward, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function btnEditBankAndRate() {
        setEditBankDetailsAndRate(true);
    }

    function btnSaveBankAndRate() {
        $('.loader').show();
        var isOk = true;
        /* 
             var msg = [], i = 0;
             msg[i++] = Common.getMessage("MSG0006");
 
             if (reqConfirmCode === "PBT" && (reqClientBank === "0" || reqClientAcctNo.trim() === "" || reqClientAcctIfsc.trim() === ""
                 || reqClientRate === "" || reqClientRate === "0")) {
 
                 isOk = false;
                 msg[i++] = (reqClientBank === "0" ? " Bank " : '');
                 msg[i++] = (reqClientAcctNo.trim() === "" ? " Account Number " : '');
                 msg[i++] = (reqClientAcctIfsc.trim() === "" ? " IFSC " : '');
                 msg[i++] = (reqClientRate === "" ? " Rate " : '');
                 msg[i++] = (reqClientRate === "0" ? " Rate " : '');
             }
         */
        if (isOk) {
            setEditBankDetailsAndRate(false);
            submitBranchResponse(false);
        } else {
            // $('.loader').hide();
            //setMsgText(Common.buildMessageFromArray(msg));
            //setMsgBox(true);
        }
    }

    function isDisableBankDetails() {
        if (rightInwardList.edit === "0") {
            return true;
        } else {
            return reqStatus !== "PBC" && ((newBranchProcess === false && editBankDetailsAndRate === false) || (reqBankDetailsConfirm === "1" && newBranchProcess));
        }
    }

    function handleAutoRefresh() {
        clearInterval(sessionStorage.myInterval);
        if (!srchAutoRefresh) {
            sessionStorage.myInterval = setInterval(() => document.getElementById("btnSearchRequest").click(), 30000);
        }
        setSrchAutoRefresh(!srchAutoRefresh);
    }

    function btnEditInwardReference() {
        setReqEditAd2References(true);
    }

    function btnSaveInwardReference() {
        $('.loader').show();
        var object1 = {
            reqSrno: reqSrno,
            reqInwardRef: reqInwardRef,
            reqZenithRef: reqZenithRef
        }
        Common.callApi(Common.apiInward, [sid, 'saveinwardreference', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.err === "") {

                setReqEditAd2References(false);
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });

    }

    function submitIConfirm() {
        $('.loader').show();
        var isOk = true;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");

        if (reqConfirmCode === "0") {
            isOk = false;
            msg[i++] = (reqConfirmCode === "0" ? " Confirm refund or reprocess." : '');
        }

        if (!acceptDeclaration) {
            isOk = false;
            msg[i++] = "Acceptance of Declaration is must. ";
        }

        if (reqConfirmCode === "PRE" && (reqConfirmComment.trim() === "" || reqConfirmQuantity.trim() === "")) {
            isOk = false;
            msg[i++] = (reqConfirmComment.trim() === "" ? " Confirmation Statement" : '');
            msg[i++] = (reqConfirmQuantity.trim() === "" ? " Reprocess Quantity" : '');
        }

        if (isOk) {
            var object1 = {
                type: 'INWARDLIST',
                reqSrno: reqSrno,
                reqConfirmCode: reqConfirmCode,
                reqConfirmComment: reqConfirmComment,
                acceptDeclaration: (acceptDeclaration ? 1 : 0),
                reqQuantity: reqQuantity,
                reqClientBank: reqClientBank,
                reqClientAcctNo: reqClientAcctNo,
                reqClientAcctIfsc: reqClientAcctIfsc,
                reqClientRate: (reqClientRate === "" ? 0 : reqClientRate),
                reqClientGst: (reqClientGst === "" ? 0 : reqClientGst),
                reqClientOthCharges: (reqClientOthCharges === "" ? 0 : reqClientOthCharges),
                reqRoundOff: (reqRoundOff === "" ? 0 : reqRoundOff),
                reqClientRefundInr: reqClientRefundInr,
                reqAgent: reqAgent,
                reqAgentCommission: reqAgentCommission,
                reqRemitterName: reqRemitterName,
                reqConfirmQuantity: (reqConfirmQuantity === "" ? 0 : reqConfirmQuantity),
                isNewOutwordTT: (isNewOutwordTT ? 1 : 0),
                newOutwordRefNo: newOutwordRefNo,
                reqClientBankNameOther: (reqClientBank === "999999999" ? reqClientBankNameOther : ""),
                reqAgentNameOther: (reqAgent === "999999999" ? reqAgentNameOther : ""),

                showPickList: Common.showPickList,
                reqRemitterType: reqRemitterType,
                pickedCorporate: pickedCorporate,
                pickedIndividual: pickedIndividual,

                reqCgstInr: reqCgstInr,
                reqSgstInr: reqSgstInr,
                reqIgstInr: reqIgstInr,
                reqUgstInr: reqUgstInr
            }
            Common.callApi(Common.apiInward, [sid, 'branchresponseiconfirm', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.blacklistedYN?.isBlackListed && resp.blacklistedYN.isBlackListed === "1") {
                    setMsgText(resp.blacklistedYN.name + " can't saved.Individual/Corporate is BLACKLISTED." + resp.blacklistedYN.tsa_master + " " + resp.blacklistedYN.tsa_data_id);
                    setMsgBox(true);
                    return;
                }
                if (resp.err === "") {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    backToList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                setRefreshCounter(refreshCounter + 1);
            });
        } else {
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }


    function saveDataRefundRequest() {
        refundRefuestCommon();
        setShowRefundConfirmModal(false);
    }

    function refundRefuestCommon() {
        // $(".loader").show();
        var object1 = {
            type: 'INWARDLIST',
            reqSrno: reqSrno,
            reqBran: reqBran,
            reqConfirmCode: reqConfirmCode,
            reqQuantity: reqQuantity,
            reqClientBank: reqClientBank,
            reqClientAcctNo: reqClientAcctNo,
            reqClientAcctIfsc: reqClientAcctIfsc,
            reqClientRate: (reqClientRate === "" ? 0 : reqClientRate),
            reqClientGst: (reqClientGst === "" ? 0 : reqClientGst),
            reqClientOthCharges: (reqClientOthCharges === "" ? 0 : reqClientOthCharges),
            reqRoundOff: (reqRoundOff === "" ? 0 : reqRoundOff),
            reqClientRefundInr: reqClientRefundInr,
            reqAgent: reqAgent,
            reqAgentCommission: reqAgentCommission,
            reqRemitterName: reqRemitterName,
            isNewOutwordTT: (isNewOutwordTT ? 1 : 0),
            newOutwordRefNo: newOutwordRefNo,
            reqClientBankNameOther: (reqClientBank === "999999999" ? reqClientBankNameOther : ""),
            reqAgentNameOther: (reqAgent === "999999999" ? reqAgentNameOther : ""),

            showPickList: Common.showPickList,
            reqRemitterType: reqRemitterType,
            pickedCorporate: pickedCorporate,
            pickedIndividual: pickedIndividual,
            reqCgstInr: reqCgstInr,
            reqSgstInr: reqSgstInr,
            reqIgstInr: reqIgstInr,
            reqUgstInr: reqUgstInr,
            reqGSTTaxable: reqGSTTaxable,
            reqExecutive: pickedExecutive?.id?.split('^')[1] || 0,
            reqSubExecutive: pickedSubExecutive?.id?.split('^')[1] || 0,
            reqAgentGroupCode: agentGroupCode || 0,
            reqAgentAccountCode: agentAccountCode || 0,
        }
        Common.callApi(Common.apiInward, [sid, 'branchresponserefundrequest', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.blacklistedYN?.isBlackListed && resp.blacklistedYN.isBlackListed === "1") {
                setMsgText(resp.blacklistedYN.name + " can't saved.Individual/Corporate is BLACKLISTED." + resp.blacklistedYN.tsa_master + " " + resp.blacklistedYN.tsa_data_id);
                setMsgBox(true);
                return;
            }
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                backToList();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function refundRequest() {
        //$('.loader').show();
        var isOk = true;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");

        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");


        if (reqRemitterType === "I" && pickedIndividual === null) {
            isOk = false;
            msg[i++] = "Individual";
        }
        if (reqRemitterType === "E" && pickedCorporate === null) {
            isOk = false;
            msg[i++] = "Entity";
        }

        if (reqConfirmCode === "PBT" && (reqClientRate === "" || reqClientRate === "0")) {
            isOk = false;
            msg[i++] = (reqClientRate === "" ? " Rate " : '');
            msg[i++] = (reqClientRate === "0" ? " Rate " : '');
        }

        if (isNewOutwordTT && newOutwordRefNo.trim() === "") {
            isOk = false;
            msg[i++] = (newOutwordRefNo.trim() === "" ? " New Outward TT Ref No " : '');
        } else {
            if (isNewOutwordTT === false && reqConfirmCode === "PBT" && (reqClientBank === "0" || reqClientAcctNo.trim() === "" || reqClientAcctIfsc.trim() === "")) {
                isOk = false;
                msg[i++] = (reqClientBank === "0" ? " Bank " : '');
                msg[i++] = (reqClientAcctNo.trim() === "" ? " Account Number " : '');
                msg[i++] = (reqClientAcctIfsc.trim() === "" ? " IFSC " : '');
            }
        }
        if ((reqRemitterType === "I") && (srchStatus === "CRF") && !pickedExecutive?.id?.split('^')[1]) {
            isOk = false;
            msg[i++] = " Executive. ";
        }
        if (reqRemitterType === "C" && pickedCorporate === null) {
            isOk = false;
            msg[i++] = "Corporate.";
        }

        if (isOk) {
            if (Common.showPickList) {
                setShowRefundConfirmModal(true);
                return;
            }
            refundRefuestCommon();
        } else {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }

    function draftRefundRequest() {
        $('.loader').show();
        var isOk = true;
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        if (isOk) {
            var object1 = {
                reqSrno: reqSrno,
                reqConfirmCode: reqConfirmCode,
                reqQuantity: reqQuantity,
                reqClientBank: reqClientBank,
                reqClientAcctNo: reqClientAcctNo,
                reqClientAcctIfsc: reqClientAcctIfsc,
                reqClientRate: (reqClientRate === "" ? 0 : reqClientRate),
                reqClientGst: (reqClientGst === "" ? 0 : reqClientGst),
                reqClientOthCharges: (reqClientOthCharges === "" ? 0 : reqClientOthCharges),
                reqRoundOff: (reqRoundOff === "" ? 0 : reqRoundOff),
                reqClientRefundInr: reqClientRefundInr,
                reqAgent: reqAgent,
                reqAgentCommission: reqAgentCommission,
                reqRemitterName: reqRemitterName,
                isNewOutwordTT: (isNewOutwordTT ? 1 : 0),
                newOutwordRefNo: newOutwordRefNo,
                reqClientBankNameOther: (reqClientBank === "999999999" ? reqClientBankNameOther : ""),
                reqAgentNameOther: (reqAgent === "999999999" ? reqAgentNameOther : ""),

                showPickList: Common.showPickList,
                reqRemitterType: reqRemitterType,
                pickedCorporate: pickedCorporate,
                pickedIndividual: pickedIndividual,

                reqCgstInr: reqCgstInr,
                reqSgstInr: reqSgstInr,
                reqIgstInr: reqIgstInr,
                reqUgstInr: reqUgstInr,
                reqExecutive: pickedExecutive?.id?.split('^')[1] || 0,
                reqSubExecutive: pickedSubExecutive?.id?.split('^')[1] || 0,
                reqAgentGroupCode: agentGroupCode || 0,
                reqAgentAccountCode: agentAccountCode || 0,
            }
            Common.callApi(Common.apiInward, [sid, 'branchresponserefundrequestdraft', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    backToList();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                setRefreshCounter(refreshCounter + 1);
            });
        } else {
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }

    function handleIsNewOutwordTT() {
        setIsNewOutwordTT(!isNewOutwordTT);
    }

    function findZenithRefno() {
        const obj = {
            reqSrno: reqSrno,
            reqissuer: reqIssuer,
            inwardref: reqInwardRef
        }
        Common.callApi(Common.apiInward, [sid, "findrefno", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setReqZenithRef(resp.refno);
                setReqRemitterName(resp.remittername);
            } else {
                setMsgBox(true);
                setMsgText(resp.err);
            }
        });
    }

    function sendBackToBank() {
        $('.loader').show();
        var object1 = {
            reqSrno: reqSrno
        }
        Common.callApi(Common.apiInward, [sid, 'sendbacktobank', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                backToList();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function handleOnChangeRate(v) {
        setReqClientRate(v);
        setReqClientRefundInr(((reqQuantity * v) - reqClientGst - reqClientOthCharges + 1 * reqRoundOff).toFixed(2));
        // calculateCharges(v, 'S');
    }
    function handleOnChangeOthCharges(v) {
        setReqClientOthCharges(v);
        setReqClientRefundInr(((reqQuantity * reqClientRate) - reqClientGst - v + 1 * reqRoundOff).toFixed(2));
        // calculateCharges(v, 'B');
    }
    function handleOnChangeGst(v) {
        setReqClientGst(v);
        setReqClientRefundInr(((reqQuantity * reqClientRate) - v - reqClientOthCharges + 1 * reqRoundOff).toFixed(2));
    }

    function handleOnChangeRoundOff(v) {
        setReqRoundOff(v);
        setReqClientRefundInr(((reqQuantity * reqClientRate) - reqClientGst - reqClientOthCharges + 1 * v).toFixed(2));
    }

    function autoCalculateGst() {
        var TaxableValue = 0;
        TaxableValue = Common.calcGSTTaxableValue(reqQuantity * reqClientRate, reqClientOthCharges * 1);
        setReqTaxableValue(TaxableValue);
        var Gst = 0;
        Gst = Common.calcGSTAmount(TaxableValue);
        var total = ((reqQuantity * reqClientRate) - Gst - reqClientOthCharges);
        var Rounded = Math.round(total);
        var roundoff = (Rounded - total).toFixed(2);

        setReqClientGst(Gst);
        setReqRoundOff(roundoff);
        setReqClientRefundInr(((reqQuantity * reqClientRate) - Gst - reqClientOthCharges + roundoff * 1).toFixed(2));
    }

    function onClickRefundAgain() {
        setReqRefundDate(new Date());
        setExecuteRefundAgain(true);
    }

    function btnFetchBackoffice() {
        if (fxTranNo === "") {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                srno: reqSrno,
                backsrno: fxTranNo
            }
            Common.callApi(Common.apiBackoffice, [sid, 'fetchreverse', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.recordfound === 1) {
                    setBackOfficeData(resp[0]);
                    var charges = resp.chargesTable;
                    var i, tcs = 0, srvchrg = 0, rndoff = 0, gst = 0;
                    for (i = 0; i < charges.length; i++) {
                        // console.log(charges[i].ch_desc + " : " + charges[i].ch_amount + " : " + charges[i].ch_code);
                        if (charges[i].ch_code === "61" || charges[i].ch_code === "62" || charges[i].ch_code === "63"
                            || charges[i].ch_code === "64" || charges[i].ch_code === "65" || charges[i].ch_code === "66"
                        ) {
                            tcs = tcs + charges[i].ch_amount * 1;
                        }
                        if (charges[i].ch_code === "31" || charges[i].ch_code === "32" || charges[i].ch_code === "33" || charges[i].ch_code === "34") {
                            gst = gst + charges[i].ch_amount * 1;
                        }
                        if (charges[i].ch_code === "1") {
                            srvchrg = srvchrg + charges[i].ch_amount * 1;
                        }
                        if (charges[i].ch_code === "999") {
                            rndoff = rndoff + charges[i].ch_amount * 1;
                        }
                    }

                    setFtCalcSrvChrg(srvchrg);
                    setFtCalcGst(gst);
                    setFtCalcRoundOff(rndoff);
                    setFtOrderDate(resp[0].orderDate);

                    setShowFetchTransaction(true);

                    //console.log(resp[0].clientNm);
                    console.log('gst : ', gst, ' srv chrg : ', srvchrg, ' rnd ', rndoff, ' cl ', resp[0].clientNm);
                    console.log(resp[0]);
                } else {
                    setMsgText("Transaction not found.");
                    setMsgBox(true);
                }
            });
        }
    }

    function updateCharges() {
        if (reqQuantity === backOfficeData.isdQty & reqIsd === backOfficeData.isd) {
            setReqRemitterName(backOfficeData.refundToName);
            setReqClientAcctNo(backOfficeData.refundToAccount);
            setReqClientAcctIfsc(backOfficeData.refundToIfsc);

            setReqClientRate(backOfficeData.saleRate);
            setReqClientOthCharges(ftCalcSrvChrg);
            setReqClientGst(ftCalcGst);
            setReqRoundOff(-ftCalcRoundOff);
            setReqClientRefundInr(((reqQuantity * backOfficeData.saleRate) - ftCalcGst - ftCalcSrvChrg + (-1 * ftCalcRoundOff)).toFixed(2));
            setShowFetchTransaction(false);

            var object1 = {
                reqSrno: reqSrno,
                fxTranNo: fxTranNo
            }
            Common.callApi(Common.apiInward, [sid, 'updatefetchbackoffice', JSON.stringify(object1)], function (result) {
            });
            setMsgText("Form Updated");
            setMsgBox(true);
        } else {
            setShowFetchTransaction(false);
            setMsgText("Can Not Update. ISD or quantity does not match.");
            setMsgBox(true);
        }
    }

    function canEdit() {
        if (rightInwardList.edit === "1") {
            return true;
        } else {
            return false;
        }
    }

    const handleRemitterTypeChange = (v) => {
        setReqRemitterType(v);
        setPickedCorporate(null);
        setPickedIndividual(null);
        setReqRemitterName('');
        // calculateCharges(v, 'I');
    }

    const handleCorporateValue = (value) => {
        setPickedCorporate(value);
        var val = value.id.split("^");
        setReqRemitterName(val[10]);
        // calculateCharges(value, 'C');
    }

    const handleIndividualValue = (value) => {
        setPickedIndividual(value);
        var val = value.id.split("^");
        setReqRemitterName(val[3]);
    }

    const newIndividual = (btnype) => {
        setShowIndividualForm(true);
        if (btnype === "E" && pickedIndividual != null) setScrIndividual("E");
        else setScrIndividual("A");
    }

    const hideIndividualProfile = (val, individualsrno, blacklistedYN, master, dataid, name, idSrno = 0) => {
        setShowIndividualForm(val);
        if (blacklistedYN == '1') {
            setMsgText(name + " saved with BLACKLISTED individual." + master + " " + dataid);
            setMsgBox(true);
            setPickedIndividual(null);
            return;
        }
        if (individualsrno > 0) {
            const obj = {
                individualsrno: individualsrno,
                idSrno: idSrno,
                type: "PURCHASE"
            }
            Common.callApi(Common.apiIndividualProfile, [sid, "individualidfrompicklist", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                console.log("RESPONSE IS  ", resp);
                const desc = resp.desc.split("^");
                if (resp.id === "") setPickedIndividual(null);
                else handleNewIndiviualChange({ ...resp, desc: `${desc.slice().join("  ^  ")}` });
                // `${desc.slice(0, 3).join(" ")} ^ ${desc[3]} ^ ${desc.slice(4, 7).join(" ")}  ^    ${desc[7]}`
            });
        }
    }

    const handleNewIndiviualChange = (value) => {
        setPickedIndividual(value);
        var id = value.id.split("^");
        setReqRemitterName(id[3]);
        // setNIndivualSrno(id[1]);
        // setIndividualSelected(1);
        // setNCDFNum("");
    }

    // function calculateCharges(v, src) {
    //     //src = C : Corporate
    //     //src = S : Sellrate
    //     //src = B : othercharges
    //     if (!Common.showPickList) return;
    //     const obj = {
    //         reqSellRate: src === "S" ? (v === "" ? 0 : v) : reqClientRate,
    //         reqQuantity: reqQuantity,
    //         reqPurpose: '',
    //         loan: "",
    //         reqPan: "",
    //         reqRemitterType: src === 'I' ? v : reqRemitterType,
    //         pickedCorporate: src === "C" ? v : pickedCorporate,
    //         reqBranch: reqBran,
    //         reqBankChargesInr: src === "B" ? (v === "" ? 0 : v) : (reqClientOthCharges === "" ? 0 : reqClientOthCharges * 1),
    //         reqNostroChargesInr: 0
    //     }
    //     Common.callApi(Common.apiInProgress, [sid, "getcharges", JSON.stringify(obj)], result => {
    //         let resp = JSON.parse(result);
    //         setReqIgstInr(resp.igst);
    //         setReqCgstInr(resp.sgst);
    //         setReqSgstInr(resp.sgst);
    //         setReqUgstInr(resp.ugst);
    //         //setReqTCSInr(resp.tcs);
    //         setReqClientGst(resp.igst * 1 + resp.sgst * 1 + resp.cgst * 1 + resp.ugst * 1);
    //         setReqGstInr(resp.igst + resp.sgst + resp.cgst + resp.ugst);

    //         // setForexAmount(resp.forex);
    //         setReqClientRefundInr(resp.totalinrPP);
    //         setReqRoundOff(resp.roundoffPP);
    //     });
    // }

    const handlePickedExecutiveChange = (value) => {
        setPickedExecutive(value);
    }
    const handlePickedSubExecutiveChange = (value) => {
        setPickedSubExecutive(value);
    }
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setAllChecked(isChecked);

        // Update tpModuleData to reflect the "Select All" checkbox change
        const updatedModuleData = tranListData.map(item => ({
            ...item,
            ischecked: isChecked ? '1' : '0'
        }));

        setTranListData(updatedModuleData);
        const updatedBankData = isChecked ? updatedModuleData : [];
        setTPBankData(updatedBankData);
    };

    const downloadBankFile = () => {
        if (tpBankData.length === 0 || +reqPayBankCode === 0) {
            setMsgBox(true);
            setShowDownloadModal(false);
            setMsgText('Please select at least one bank.');
        } else {
            const obj = {
                reqPayBankCode: reqPayBankCode,
                tpBankData: tpBankData
            };
            Common.callApi(Common.apiInward, [sid, "checkBankCodeAvailable", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                if (resp.status) {
                    Common.callDownloadApiPost(Common.apiInward, "post", [sid, 'downloadbankfile', JSON.stringify(obj)]);
                    setShowDownloadModal(false);
                    setTranListData([]);
                    setTPBankData([]);
                } else {
                    setMsgBox(true);
                    setMsgText('Bank is not selected. Please select bank First.');
                }
            });

        }
    };
    const updateCheck = (index, e, name) => {
        const isChecked = e.target.checked;
        // console.log(isChecked);

        // Update tpModuleData to reflect the checkbox change
        const updatedModuleData = tranListData.map((item, i) => {
            if (index === i) {
                return { ...item, [name]: isChecked ? '1' : '0' };
            }
            return item;
        });

        setTranListData(updatedModuleData);

        // Update tpBankData to include only checked items
        const updatedBankData = updatedModuleData.filter(item => item.ischecked === '1');
        setTPBankData(updatedBankData);
    };
    return (
        <>
            {
                showIndividualForm ?
                    <Master_individual_profile reqObj={{ pickedIndividual: pickedIndividual, scrIndividual: scrIndividual }} value="NEW_REQUEST" hideIndividualProfile={hideIndividualProfile} />
                    :
                    <>
                        <Loginheader></Loginheader>
                        <Menu></Menu>
                        {
                            /*
                                <Container>
                                    <Row>
                                        <Col style={{ textAlign: 'left' }} >
                                            <input type="checkbox"
                                                checked={newBranchProcess}
                                                onChange={handleNewBranchProcess}
            
                                            />&nbsp;New Branch Process.
                                        </Col>
                                    </Row>
                                </Container>
            
                            */
                        }

                        {
                            showNewWindow ? <>
                                <Container fluid>
                                    <Row>
                                        <Col>
                                            <h1>New Inward</h1>
                                        </Col>
                                        <Col>
                                        </Col>
                                        <Col>
                                        </Col>
                                        <Col>
                                            {refreshCounter}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={6}>
                                            <Button variant="outline-primary" size="sm" onClick={() => backToList()}>Back</Button>&nbsp;
                                        </Col>
                                        <Col xs={6} style={{ textAlign: 'right' }} >
                                            {
                                                rightInwardReturnToBank.query === "1" && (reqStatus === "NEW" || reqStatus === "PBC" || reqStatus === "PBT" || reqStatus === "PRE") ?
                                                    <>
                                                        <Button variant="outline-primary" size="sm" onClick={() => sendBackToBank()}>Send Back To Bank</Button>
                                                    </> : null
                                            }

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            {
                                                rightInwardList.add === "1" && reqSrno === 0 ? <>
                                                    <Button variant="outline-primary" size="sm" onClick={() => saveNewInward("NEW")} disabled={disableSave}>Save</Button>&nbsp;
                                                    {
                                                        reqSrno > 0 ? <>
                                                            <Button variant="outline-primary" size="sm" onClick={() => saveNewInward("PBC")}>Save To Branch</Button>&nbsp;
                                                        </> : null
                                                    }
                                                </> : null
                                            }
                                            {
                                                (rightInwardList.add === "1" && reqSrno !== 0 && reqStatus === "NEW") ? <>
                                                    <Button variant="outline-primary" size="sm" onClick={() => sendInwardToBranch()}>To Branch</Button>&nbsp;
                                                </> : null
                                            }


                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Issuer </Form.Label>
                                                <Form.Select
                                                    value={reqIssuer}
                                                    onChange={(e) => setReqIssuer(e.target.value)}
                                                    disabled={!allowNewAdd()}
                                                >
                                                    {ddSrchIssuer.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Sr No</Form.Label>
                                                <Form.Control type="text"
                                                    value={reqSrno}
                                                    disabled={true}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Status</Form.Label>
                                                <Form.Control type="text"
                                                    value={reqStatusName}
                                                    disabled={true}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Date<span className="mandatory">*</span></Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={reqDate}
                                                    onChange={(date) => setReqDate(date)}
                                                    isClearable={allowNewAdd()}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                    }
                                                    disabled={!allowNewAdd()}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Currency<span className="mandatory">*</span></Form.Label>
                                                <Select
                                                    value={reqIsdSelect}
                                                    onChange={handleReqIsdOptions}
                                                    options={ddReqIsdOptions}
                                                    isDisabled={!allowNewAdd()}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Quantity<span className="mandatory">*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Quantity" maxLength={10}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqQuantity)}
                                                    value={reqQuantity} autoComplete="off"
                                                    disabled={!allowNewAdd()}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Location</Form.Label>
                                                <Select
                                                    value={reqBranSelect}
                                                    onChange={handleReqBranchOptions}
                                                    options={ddReqBranOptions}
                                                    isDisabled={!(rightInwardList.add === "1" && reqStatus === "NEW")}
                                                />
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                    {
                                        reqHeader.reqi_inwardrefno === "" && rightInwardList.add === "1" ? <>
                                            <Row>
                                                <Col>&nbsp;</Col>
                                            </Row>
                                            {
                                                reqEditAd2References ? <>
                                                    <Row>
                                                        <Col>
                                                            <Button variant="outline-primary" size="sm" onClick={() => btnSaveInwardReference()}>Save Reference</Button>&nbsp;
                                                        </Col>
                                                    </Row>
                                                </> : <>
                                                    <Row>
                                                        <Col>
                                                            <Button variant="outline-primary" size="sm" onClick={() => btnEditInwardReference()}>Edit Reference</Button>&nbsp;
                                                        </Col>
                                                    </Row>
                                                </>
                                            }
                                        </> : null
                                    }
                                    <Row>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>
                                                    Inward Reference&nbsp;
                                                    {
                                                        ((reqEditAd2References || reqSrno === 0) && rightInwardList.add === "1") ? <>
                                                            <span style={{ fontSize: "17px", cursor: "pointer" }} onClick={() => findZenithRefno()}><Badge bg="primary">Find</Badge></span>
                                                        </> : null
                                                    }
                                                </Form.Label>
                                                <Form.Control
                                                    type="text" placeholder="Inward Reference" maxLength={50} autoComplete="off"
                                                    value={reqInwardRef}
                                                    onChange={(e) => setReqInwardRef(e.target.value)}
                                                    disabled={!allowNewAdd() && !reqEditAd2References}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Zenith Reference</Form.Label>
                                                <Form.Control
                                                    type="text" placeholder="Zenith Reference" maxLength={50} autoComplete="off"
                                                    value={reqZenithRef}
                                                    onChange={(e) => setReqZenithRef(e.target.value)}
                                                    disabled={!allowNewAdd() && !reqEditAd2References}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} >
                                            <Form.Group >
                                                <Form.Label>Issuer Comment</Form.Label>
                                                <Form.Control as="textarea" rows={5} placeholder="Issuer Comment" maxLength={1000} autoComplete="off"
                                                    value={reqIssuerComment}
                                                    onChange={(e) => setReqIssuerComment(e.target.value)}
                                                    disabled={!allowNewAdd()}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} >
                                            <Form.Group >
                                                <Form.Label>Subject Line</Form.Label>
                                                <Form.Control
                                                    type="text" maxLength={500} autoComplete="off"
                                                    value={reqSubjectLine}
                                                    onChange={(e) => setReqSubjectLine(e.target.value)}
                                                    disabled={!allowNewAdd()}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {
                                        reqSrno * 1 > 0 && reqAdditionalComment.trim() != "" ?
                                            <>
                                                <h3><Badge bg="danger">{reqAdditionalComment}</Badge></h3>
                                            </> : <>
                                                <Row>
                                                    <Col xs={12}>
                                                        <Form.Group >
                                                            <Form.Label>Additional Comment</Form.Label>
                                                            <Form.Control
                                                                type="text" maxLength={200} autoComplete="off"
                                                                value={reqAdditionalComment}
                                                                onChange={(e) => setReqAdditionalComment(e.target.value)}
                                                                disabled={!allowNewAdd()}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </>
                                    }

                                    {
                                        reqSrno * 1 > 0 ?
                                            <>
                                                <Row>
                                                    <Col>
                                                        {
                                                            reqPaymentCredited === "1" && reqHeader.reqi_branchconfirmstatus === "PBT" ? <>
                                                                <b>
                                                                    INR : {reqHeader.reqi_paymentcreditamount} Received on : {reqHeader.reqi_paymentcreditdatedmy}&nbsp;
                                                                    wide reference number : {reqHeader.reqi_paymentcreditrefno}&nbsp;
                                                                </b>
                                                            </> : <>
                                                                <b>Payment Credit information not found</b>
                                                            </>
                                                        }
                                                    </Col>
                                                </Row>
                                            </> : null
                                    }

                                    {
                                        reqStatus !== "NEW" ? <>
                                            <Row>
                                                <Col>
                                                    <hr></hr>
                                                </Col>
                                            </Row>
                                            {
                                                canEdit() ? <>
                                                    <Row>
                                                        <Col style={{ textAlign: 'left' }} >
                                                            {/*  <!-- Declaration -->  */}
                                                            <input type="checkbox"
                                                                checked={acceptDeclaration}
                                                                onChange={handleAcceptDeclaration}
                                                                disabled={reqStatus !== "PBC"}
                                                            />&nbsp;I Declare This inward Belongs to {reqBranName} only.
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Confirmation.</Form.Label>
                                                                <Form.Select
                                                                    value={reqConfirmCode}
                                                                    onChange={(e) => setReqConfirmCode(e.target.value)}
                                                                    disabled={reqStatus !== "PBC"}
                                                                >
                                                                    <option key="0" value="0">Select</option>
                                                                    <option key="PRE" value="PRE">Reprocess</option>
                                                                    <option key="PBT" value="PBT">Refund</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>

                                                        <Col xs={6} >
                                                            <Form.Group >
                                                                <Form.Label>Confirmation Statement</Form.Label>
                                                                <Form.Control
                                                                    type="text" placeholder="Confirmation Statement" maxLength={500} autoComplete="off"
                                                                    value={reqConfirmComment}
                                                                    onChange={(e) => setReqConfirmComment(e.target.value)}
                                                                    disabled={reqStatus !== "PBC"}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {
                                                            reqConfirmCode === "PRE" ?
                                                                <>
                                                                    <Col>
                                                                        <Form.Group >
                                                                            <Form.Label>Reprocess Quantity</Form.Label>
                                                                            <Form.Control
                                                                                type="text" placeholder="Reprocess Quantity" maxLength={10} autoComplete="off"
                                                                                value={reqConfirmQuantity}
                                                                                onChange={(e) => Common.validateDecValue(e.target.value, setReqConfirmQuantity)}
                                                                                disabled={reqStatus !== "PBC"}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </> : <>
                                                                    <Col></Col>
                                                                </>
                                                        }
                                                    </Row>
                                                </> : null
                                            }

                                            {
                                                reqStatus !== "NEW" && reqConfirmCode === "PBT" ? <>
                                                    {
                                                        !isDisableBankDetails() ? <>
                                                            <Row>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>FXPLUS Transaction No : </Form.Label>
                                                                        <Form.Control type="text" placeholder="Transaction No" maxLength={10} autoComplete="off"
                                                                            value={fxTranNo}
                                                                            onChange={(e) => Common.validateNumValue(e.target.value, setFxTranNo)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                                                        <Button variant="outline-success" size="sm" onClick={(e) => btnFetchBackoffice()} >Fetch</Button>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col>&nbsp;</Col>
                                                                <Col>&nbsp;</Col>
                                                            </Row>
                                                        </> : null
                                                    }
                                                    <Row>
                                                        <Col>

                                                        </Col>
                                                    </Row>

                                                    {
                                                        Common.showPickList ?
                                                            <>
                                                                <Row>
                                                                    <Col className='col-md-3'>
                                                                        <Form.Group>
                                                                            <Form.Label>Client Type</Form.Label>
                                                                            <Form.Select
                                                                                value={reqRemitterType}
                                                                                onChange={(e) => handleRemitterTypeChange(e.target.value)}
                                                                                disabled={isDisableBankDetails()}
                                                                            >
                                                                                <option value="I">Individual</option>
                                                                                <option value="C">Corporate</option>
                                                                            </Form.Select>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    {
                                                                        (reqRemitterType === "I") ?
                                                                            <Col className='col-md-9'>
                                                                                <Form.Group>
                                                                                    <Form.Label>Individual<span className='coloThemeRed'>*</span>
                                                                                        <span className='tranNewFormText' onClick={() => newIndividual("A")}>Not in list? Create New</span>
                                                                                        &nbsp;&nbsp;
                                                                                        <span className='tranNewFormText' onClick={() => newIndividual("E")}>Edit</span>
                                                                                    </Form.Label>
                                                                                    <AsyncSelect
                                                                                        cacheOptions={false}
                                                                                        defaultOptions={false}
                                                                                        value={pickedIndividual}
                                                                                        getOptionLabel={e => e.label + ' '}
                                                                                        getOptionValue={e => e.id}
                                                                                        loadOptions={Picklist.fetchIndividualProfilePicklist} // location = 1 , 2
                                                                                        onInputChange={Picklist.handleInputChange}
                                                                                        formatOptionLabel={Picklist.formatOptionLabel}
                                                                                        components={{ Menu: Picklist.menu }}
                                                                                        onChange={handleIndividualValue}
                                                                                        isDisabled={isDisableBankDetails()}
                                                                                    >
                                                                                    </AsyncSelect>
                                                                                </Form.Group>
                                                                            </Col>
                                                                            : (reqRemitterType === "C") ?
                                                                                <Col className='col-md-9'>
                                                                                    <Form.Group>
                                                                                        <Form.Label>Ledger<span className='coloThemeRed'>*</span></Form.Label>
                                                                                        <AsyncSelect
                                                                                            cacheOptions={false}
                                                                                            defaultOptions={false}
                                                                                            value={pickedCorporate}
                                                                                            getOptionLabel={e => e.label + ' '}
                                                                                            getOptionValue={e => e.id}
                                                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, "CORPORATE, DEALER", reqBran)} // location = 1 , 2
                                                                                            onInputChange={Picklist.handleInputChange}
                                                                                            onChange={handleCorporateValue}
                                                                                            isDisabled={isDisableBankDetails()}
                                                                                        >
                                                                                        </AsyncSelect>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                : null
                                                                    }
                                                                </Row>
                                                            </> : null
                                                    }


                                                    <Row>
                                                        <Col className='col-md-3'>
                                                            <Form.Group>
                                                                <Form.Label>Client Name</Form.Label>
                                                                <Form.Control type="text" placeholder="Client Name" maxLength={200} autoComplete="off"
                                                                    value={reqRemitterName}
                                                                    onChange={(e) => Common.validateAlpNumSpl1Value(e.target.value, setReqRemitterName)}
                                                                    disabled={isDisableBankDetails() || Common.showPickList}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {
                                                            (reqRemitterType === "I") && (srchStatus === "CRF" || pickedExecutive?.label !== '') &&
                                                            <>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={pickedExecutive}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={Picklist.fetchExecutivePicklist}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handlePickedExecutiveChange}
                                                                        isDisabled={isDisableBankDetails()}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Col>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Label>Sub Executive</Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={pickedSubExecutive}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={Picklist.fetchSubExecutivePicklist}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handlePickedSubExecutiveChange}
                                                                        isDisabled={isDisableBankDetails()}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Col>
                                                            </>
                                                        }
                                                    </Row>

                                                    <Row>
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Client Rate<span className="mandatory">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="Client Rate" maxLength={10}
                                                                    onChange={(e) => Common.validateDecValue(e.target.value, handleOnChangeRate)}
                                                                    value={reqClientRate} autoComplete="off"
                                                                    disabled={isDisableBankDetails()}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Other Charges</Form.Label>
                                                                <Form.Control type="text" placeholder="Other Charges" maxLength={10}
                                                                    onChange={(e) => Common.validateDecValue(e.target.value, handleOnChangeOthCharges)}
                                                                    value={reqClientOthCharges} autoComplete="off"
                                                                    disabled={isDisableBankDetails()}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {
                                                            !Common.showPickList &&
                                                            <Col>
                                                                <Form.Group >
                                                                    <Form.Label>
                                                                        Total GST&nbsp;
                                                                        {
                                                                            isDisableBankDetails() === false ? <>
                                                                                <span style={{ fontSize: "17px", cursor: "pointer" }} onClick={() => autoCalculateGst()}><Badge bg="primary">Calculate</Badge></span>
                                                                                Taxable : {reqTaxableValue}
                                                                            </> : null
                                                                        }

                                                                    </Form.Label>
                                                                    <Form.Control type="text" placeholder="Total GST" maxLength={10}
                                                                        onChange={(e) => Common.validateDecValue(e.target.value, handleOnChangeGst)}
                                                                        value={reqClientGst} autoComplete="off"
                                                                        disabled={isDisableBankDetails()}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        }
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Round off</Form.Label>
                                                                <Form.Control type="text" placeholder="Round off" maxLength={10}
                                                                    onChange={(e) => Common.validateDecValue(e.target.value, handleOnChangeRoundOff)}
                                                                    value={reqRoundOff} autoComplete="off"
                                                                    disabled={isDisableBankDetails() || Common.showPickList}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                    {
                                                        Common.showPickList &&
                                                        <Row>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group >
                                                                    <Form.Label>CGST</Form.Label>
                                                                    <Form.Control type="text" placeholder="CGST" maxLength={10} autoComplete="off"
                                                                        disabled
                                                                        value={reqCgstInr}
                                                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqCgstInr)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group >
                                                                    <Form.Label>SGST</Form.Label>
                                                                    <Form.Control type="text" placeholder="SGST" maxLength={10} autoComplete="off"
                                                                        disabled
                                                                        value={reqSgstInr}
                                                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqSgstInr)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group >
                                                                    <Form.Label>IGST</Form.Label>
                                                                    <Form.Control type="text" placeholder="IGST" maxLength={10} autoComplete="off"
                                                                        disabled
                                                                        value={reqIgstInr}
                                                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqIgstInr)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group >
                                                                    <Form.Label>UGST</Form.Label>
                                                                    <Form.Control type="text" placeholder="IGST" maxLength={10} autoComplete="off"
                                                                        disabled
                                                                        value={reqUgstInr}
                                                                        onChange={(e) => Common.validateDecValue(e.target.value, setReqUgstInr)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    }
                                                </> : null
                                            }

                                            {
                                                reqStatus === "PBC" && newBranchProcess ? <>
                                                    {
                                                        canEdit() ? <>
                                                            <Row><Col>&nbsp;</Col></Row>
                                                            <Row>
                                                                <Col>
                                                                    <Button variant="outline-primary" size="sm" onClick={() => submitIConfirm()}>I Confirm</Button>&nbsp;
                                                                </Col>
                                                            </Row>
                                                        </> : null
                                                    }
                                                </> : null
                                            }

                                        </> : <>
                                        </>
                                    }
                                    {
                                        reqConfirmCode === "PBT" && reqRefundApprovedAccount * 1 === 0 && newBranchProcess === false && reqStatus === "PBT" ? <>
                                            <Row>
                                                <Col>
                                                    {
                                                        editBankDetailsAndRate ? <>
                                                            <span className="handCursor" onClick={(e) => btnSaveBankAndRate()}>
                                                                <Badge bg="danger">Save Changes</Badge>
                                                            </span>
                                                        </> : <>
                                                            <span className="handCursor" onClick={(e) => btnEditBankAndRate()}>
                                                                <Badge bg="danger">Edit Bank and Rate</Badge>
                                                            </span>
                                                        </>
                                                    }
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {
                                        reqStatus !== "NEW" && reqConfirmCode === "PBT" ? <>
                                            <Row>
                                                <Col>
                                                    <span><b>Total Refund Amount :</b>{reqClientRefundInr}</span>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col>
                                                    <input type="checkbox"
                                                        checked={isNewOutwordTT}
                                                        onChange={handleIsNewOutwordTT}
                                                        disabled={isDisableBankDetails()}
                                                    />&nbsp;I have done New Outword TT against this refund.
                                                </Col>
                                            </Row>
                                            {
                                                isNewOutwordTT ? <>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>New Outword TT Ref No<span className="mandatory">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="New Ref No" maxLength={50}
                                                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setNewOutwordRefNo)}
                                                                    value={newOutwordRefNo} autoComplete="off"
                                                                    disabled={isDisableBankDetails()}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                        </Col>
                                                        <Col>
                                                        </Col>
                                                        <Col>
                                                        </Col>
                                                    </Row>
                                                </> : <>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Client Bank </Form.Label>
                                                                <Select
                                                                    value={reqClientBankSelect}
                                                                    onChange={handleReqClientBankOptions}
                                                                    options={ddReqClientBankOptions}
                                                                    isDisabled={isDisableBankDetails()}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {
                                                            reqClientBank === "999999999" ?
                                                                <>
                                                                    <Col>
                                                                        <Form.Group>
                                                                            <Form.Label>Client Bank Name </Form.Label>
                                                                            <Form.Control type="text" placeholder="Bank Name" maxLength={100} autoComplete="off"
                                                                                value={reqClientBankNameOther}
                                                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqClientBankNameOther)}
                                                                                disabled={isDisableBankDetails()}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </> : null
                                                        }
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Client Bank Account Number</Form.Label>
                                                                <Form.Control type="text" placeholder="Account Number" maxLength={50} autoComplete="off"
                                                                    value={reqClientAcctNo}
                                                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqClientAcctNo)}
                                                                    disabled={isDisableBankDetails()}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Client Bank IFSC </Form.Label>
                                                                <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                    value={reqClientAcctIfsc}
                                                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqClientAcctIfsc)}
                                                                    disabled={isDisableBankDetails()}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {
                                                            reqClientBank === "999999999" ? <>
                                                            </> : <>
                                                                <Col></Col>
                                                            </>
                                                        }

                                                    </Row>

                                                    <Row>
                                                        {/* <Col>
                                                            <Form.Group>
                                                                <Form.Label>Agent</Form.Label>
                                                                <Select
                                                                    value={reqAgentSelect}
                                                                    onChange={handleReqAgentOptions}
                                                                    options={ddReqAgentOptions}
                                                                    isDisabled={isDisableBankDetails()}
                                                                />
                                                            </Form.Group>
                                                        </Col> */}
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions={false}
                                                                    defaultOptions={false}
                                                                    value={reqAgentSelect}
                                                                    getOptionLabel={e => e.label + ' '}
                                                                    getOptionValue={e => e.id}
                                                                    loadOptions={(search) => Picklist.fetchEremitAgentPickList(search, reqBran)}
                                                                    onInputChange={Picklist.handleInputChange}
                                                                    onChange={handleReqAgentOptions}
                                                                    isDisabled={isDisableBankDetails()}
                                                                >
                                                                </AsyncSelect>
                                                            </Form.Group>
                                                        </Col>
                                                        {
                                                            reqAgent === "999999999" ? <>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>Agent Name </Form.Label>
                                                                        <Form.Control type="text" placeholder="Agent Name" maxLength={100} autoComplete="off"
                                                                            value={reqAgentNameOther}
                                                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqAgentNameOther)}
                                                                            disabled={isDisableBankDetails()}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>

                                                            </> : null
                                                        }
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Agent Commission<span className="mandatory">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="Commission" maxLength={10}
                                                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqAgentCommission)}
                                                                    value={reqAgentCommission} autoComplete="off"
                                                                    disabled={isDisableBankDetails() || reqAgent === "999999999"}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col></Col>
                                                        {
                                                            reqAgent === "999999999" ? <>
                                                            </> : <>
                                                                <Col></Col>
                                                            </>
                                                        }

                                                    </Row>
                                                </>
                                            }
                                        </> : null
                                    }
                                    {
                                        reqStatus === "PBC" && newBranchProcess === false ? <>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    <Button variant="outline-primary" size="sm" onClick={() => submitBranchResponse(true)}>Submit Confirmation</Button>&nbsp;
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {
                                        (reqStatus === "PBT" || reqStatus === "PBC") && newBranchProcess && reqConfirmCode === "PBT" && reqBankDetailsConfirm === "0" ? <>
                                            <Row><Col>&nbsp;</Col></Row>
                                            {
                                                canEdit() ? <>
                                                    <Row>
                                                        <Col>
                                                            <Button variant="outline-primary" size="sm" onClick={() => draftRefundRequest()}>Draft</Button>&nbsp;
                                                            <Button variant="outline-primary" size="sm" onClick={() => refundRequest()}>Refund Request</Button>&nbsp;
                                                        </Col>
                                                    </Row>
                                                </> : null
                                            }


                                        </> : null
                                    }
                                    {/* Reprocess confirmation section */}
                                    {
                                        reqStatus === "PRE" && rightInwardList.add === "1" ? <>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Reprocess Date<span className="mandatory">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={reqReprocessedDate}
                                                            onChange={(date) => setReqReprocessedDate(date)}
                                                            isClearable
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                            }
                                                            disabled={!(reqStatus === "PRE")}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                                        <Button variant="outline-primary" size="sm" onClick={() => submitReprocessed()}>Reprocessed</Button>&nbsp;
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                </Col>
                                                <Col>
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {
                                        reqBookingVoucher.trim() !== "" ? <>
                                            <Row>
                                                <Col>
                                                    Booked in : {reqBookingVoucher}
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {
                                        reqStatus === "REP" ? <>
                                            <Row>
                                                <Col>
                                                    Reprocesseed On : {reqReprocessedDateDmy}
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {
                                        reqStatus === "RAA" && rightInwardRefundApproveBm.query === "1" && reqRefundApprovedZm === "0" ? <>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    <Button variant="outline-primary" size="sm" onClick={() => clickApproveRefundBm()}>BM Approve Refund</Button>&nbsp;
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {
                                        reqStatus === "RAA" && rightInwardRefundApprove.query === "1" && reqRefundApprovedZm === "0" ? <>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    <Button variant="outline-primary" size="sm" onClick={() => clickApproveRefund()}>ZM Approve Refund</Button>&nbsp;
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {/* Account Approval section */}
                                    { // PBT //RFA
                                        reqStatus === "PBT" && rightInwardRefundApproveAccount.query === "1" && reqRefundApprovedAccount === "0" && reqBankDetailsConfirm === "1" && isNewOutwordTT === false ? <>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Booking Voucher<span className="mandatory">*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Booking Voucher" maxLength={49}
                                                            onChange={(e) => setReqBookingVoucher(e.target.value)}
                                                            value={reqBookingVoucher} autoComplete="off"

                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>&nbsp;</Col>
                                                <Col>&nbsp;</Col>
                                                <Col>&nbsp;</Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    <Button variant="outline-primary" size="sm" onClick={() => clickApproveRefundAccount()}>Account Approve Refund</Button>&nbsp;
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {/* Refund process section */}
                                    {
                                        rightInwardRefundExecute.query === "1" && reqRefundApproved === "1" && (reqStatus === "RFA" || executeRefundAgain) ? <>
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Refund Date<span className="mandatory">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={reqRefundDate}
                                                            onChange={(date) => setReqRefundDate(date)}

                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                            }
                                                            disabled={!(reqStatus === "RFA" || executeRefundAgain) || true}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Refund Bank</Form.Label>
                                                        <Form.Select
                                                            value={reqPayBankCode}
                                                            onChange={(e) => setReqBankCode(e.target.value)}  >
                                                            {ddReqPayBankOptions.map((res) =>
                                                                <option key={res.value} value={res.value}>{res.name}</option>
                                                            )}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Refund Reference</Form.Label>
                                                        <Form.Control type="text" placeholder="Reference" maxLength={255} autoComplete="off"
                                                            value={reqPayBankRef}
                                                            onChange={(e) => setReqPayBankRef(e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>Refunded Amount</Form.Label>
                                                        <Form.Control type="text" placeholder="Reference" maxLength={50} autoComplete="off"
                                                            value={reqPayRefundedAmount}
                                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqPayRefundedAmount)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row><Col>&nbsp;</Col></Row>
                                            <Row>
                                                <Col>
                                                    <Button variant="outline-primary" size="sm" onClick={() => clickRefundExecuted()}>Refunded</Button>&nbsp;
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    {
                                        reqRefundExecuted === "1" ? <>
                                            {
                                                rightInwardRefundExecute.add === "1" && reqRefundExecuted === "1" ? <>
                                                    <Row>
                                                        <Col>
                                                            <span style={{ fontSize: "17px", cursor: "pointer" }} onClick={() => onClickRefundAgain()}><Badge bg="primary">Refund Again</Badge></span>
                                                        </Col>
                                                    </Row>
                                                </> : null
                                            }
                                            <Row>
                                                <Col>
                                                    <b>Refunded Rs. {reqPayRefundedAmount} on {reqRefundDateDmy} from {reqPayBankCode} : {reqPayBankName} reference {reqPayBankRef}</b>
                                                </Col>
                                            </Row>
                                        </> : null
                                    }
                                    <Row className='border-bottom'>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <h5>Documents</h5>
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    {
                                        rightInwardList.edit === "1" ? <>
                                            <Row>
                                                <Col>
                                                    <Form.Group >
                                                        <Form.Label>Remark</Form.Label>
                                                        <Form.Control type="text" value={reqDocRemark}
                                                            onChange={(e) => setReqDocRemark(e.target.value)}
                                                        ></Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group controlId='fileToUpload'>
                                                        <Form.Label>File (Max 10MB)</Form.Label>
                                                        <Form.Control type="file"></Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                                        <Button variant="outline-success" size="sm" onClick={(e) => btnUploadFile()} >Upload</Button>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </> : null
                                    }

                                    {
                                        // Earlier document block
                                        reqStatus === "PBC" ? <>

                                        </> : null
                                    }
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>

                                            <Table responsive striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <td>Remark</td>
                                                        <td>File Name</td>
                                                        <td>&nbsp;</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {docListData.map((res) =>
                                                        <tr key={res.doc_filename}>

                                                            <td className='divHide'>{res.doc_srno}</td>
                                                            <td>{res.doc_remark}</td>
                                                            <td>{res.doc_filename}</td>
                                                            <td>
                                                                <div className="colorThemeBlue">
                                                                    {
                                                                        (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                                            || res.doc_ext === "jpg" || res.doc_ext === "png") ? <>
                                                                            <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                                <FontAwesomeIcon icon={faEye} />
                                                                            </span>&nbsp;
                                                                        </> : null
                                                                    }

                                                                    <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                                        <FontAwesomeIcon icon={faFileDownload} />
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row className='border-bottom'>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <h5>Comment</h5>
                                        </Col>
                                    </Row>
                                    {
                                        canEdit() ? <>
                                            <Row>
                                                <Col xs={6}>
                                                    <Form.Group >
                                                        <Form.Label>Comment</Form.Label>
                                                        <Form.Control type="text" placeholder="Comment" maxLength={100}
                                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setRemark)}
                                                            value={remark} autoComplete="off" />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group >
                                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                                        <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </> : null
                                    }


                                    <Row>
                                        <Col>
                                            <Table responsive >
                                                <thead>
                                                    <tr>
                                                        <td>Time Stamp</td>
                                                        <td>User</td>
                                                        <td>Remark</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {commentListData.map((res) =>
                                                        <tr key={res.icmnt_lineno}>
                                                            <td>{(res.icmnt_createdat).split('/').reverse().join('/')}</td>
                                                            <td>{res.um_username}</td>
                                                            <td>{res.icmnt_desc}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row className='border-bottom'>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <h5>Cover List</h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Table responsive striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <td>Issuer</td>
                                                        <td>Deal Id</td>
                                                        <td>Deal Rate</td>
                                                        <td>Deal Value</td>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {coverListData.map((res) =>
                                                        <tr key={res.tric_lineno}>
                                                            <td>{res.tric_bank}&nbsp;:&nbsp;{res.issuer_name}</td>
                                                            <td>{res.tric_dealno}</td>
                                                            <td>{res.tric_rate}</td>
                                                            <td>{res.tric_value}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row className='border-bottom'>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        <Col>
                                            <h5>Activity Log</h5>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Table responsive striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <td>Time Stamp</td>
                                                        <td>User Name</td>
                                                        <td>Remark</td>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {logListData.map((res) =>
                                                        <tr key={res.ireqlog_rndnum}>
                                                            <td>{res.ireqlog_logtime}</td>
                                                            <td>{res.um_username}</td>
                                                            <td>{res.ireqlog_rmk}</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <Button variant="outline-primary" size="sm" onClick={() => backToList()}>Back</Button>&nbsp;
                                            {
                                                (rightInwardList.add === "1" && !(reqStatus === "REP" || reqStatus === "REF" || reqStatus === "RAA"))
                                                    || (rightInwardRefundApproveAccount.add === "1" && reqRefundApprovedAccount === "0")
                                                    || (rightInwardRefundExecute.query === "1" && reqRefundApproved === "1" && !(reqStatus === 'REF' || reqStatus === 'NTT'))
                                                    || (reqStatus === "RAA" && rightInwardRefundApprove.query === "1" && reqRefundApprovedZm === "0")
                                                    || sessionStorage.getItem('userSrno') === "1"
                                                    ? <>
                                                        <input type="checkbox"
                                                            checked={showUnlockTran}
                                                            onChange={handleShowUnlockTran}
                                                        />&nbsp;
                                                        {
                                                            showUnlockTran && (
                                                                (reqRefundApprovedAccount * 1 === 0 && rightInwardRefundApproveAccount.add === "1")
                                                                || (rightInwardRefundExecute.query === "1" && reqRefundApproved === "1" && reqStatus === 'RFA')
                                                                || (reqStatus === "RAA" && rightInwardRefundApprove.query === "1" && reqRefundApprovedZm === "0")
                                                                || sessionStorage.getItem('userSrno') === "1"
                                                            ) ? <>
                                                                <Button variant="outline-danger" size="sm" onClick={() => unlockTransaction()}>Unlock</Button>&nbsp;
                                                            </> : null
                                                        }
                                                    </> : null
                                            }
                                        </Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                </Container>
                            </> : <>

                            </>
                        }
                        {
                            showFilter ?
                                <>

                                    <Container fluid >
                                        <Row>
                                            <Col>
                                                <h1>Inward</h1>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {
                                                srchSrno.trim() === "" ? <>
                                                    <Col xs={6}>
                                                        <Form.Group>
                                                            <Form.Label>Status</Form.Label>
                                                            <Form.Select
                                                                value={srchStatus}
                                                                onChange={(e) => onChangeSrchStatus(e.target.value)}  >
                                                                {ddReqStatusOptions.map((res) =>
                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                )}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={3}>
                                                        <Form.Group >
                                                            <Form.Label>Issuer </Form.Label>
                                                            <Form.Select
                                                                value={srchIssuer}
                                                                onChange={(e) => setSrchIssuer(e.target.value)}  >
                                                                {ddSrchIssuer.map((res) =>
                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                )}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </> : <></>
                                            }

                                            <Col xs={3}>
                                                <Form.Group >
                                                    <Form.Label>Sr No</Form.Label>
                                                    <Form.Control type="text" placeholder="Sr No" maxLength={30}
                                                        onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSrchSrno)}
                                                        value={srchSrno} autoComplete="off"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        {
                                            srchSrno.trim() === "" ? <>
                                                <Row>
                                                    <Col>

                                                        <Form.Group>
                                                            <Form.Label>Branch</Form.Label>
                                                            <Select
                                                                value={srchBranSelect}
                                                                onChange={handleSrchBranchOptions}
                                                                options={ddSrchBranOptions}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        srchStatus === "ALL" || srchStatus === "REP" || srchStatus === "REF" || srchStatus === "CLS" || srchStatus === "NTT" ? <>
                                                            <Col>
                                                                <Form.Group>
                                                                    <Form.Label>From Date</Form.Label>
                                                                    <DatePicker className="form-control"
                                                                        selected={srchFromDate}
                                                                        onChange={(date) => setSrchFromDate(date)}
                                                                        isClearable
                                                                        dateFormat="dd/MM/yyyy"
                                                                        showYearDropdown
                                                                        showMonthDropdown
                                                                        useShortMonthInDropdown
                                                                        dropdownMode="select"
                                                                        peekNextMonth
                                                                        customInput={
                                                                            <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col>
                                                                <Form.Group>
                                                                    <Form.Label>To Date</Form.Label>
                                                                    <DatePicker className="form-control"
                                                                        selected={srchToDate}
                                                                        onChange={(date) => setSrchToDate(date)}
                                                                        isClearable
                                                                        dateFormat="dd/MM/yyyy"
                                                                        showYearDropdown
                                                                        showMonthDropdown
                                                                        useShortMonthInDropdown
                                                                        dropdownMode="select"
                                                                        peekNextMonth
                                                                        customInput={
                                                                            <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                                        }
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </> : <>
                                                            <Col></Col>
                                                            <Col></Col>
                                                        </>
                                                    }
                                                    <Col>
                                                    </Col>
                                                </Row>
                                            </> : null
                                        }

                                        <Row><Col>&nbsp;</Col></Row>
                                        <Row>
                                            <Col xs={12}>
                                                <Button id="btnSearchRequest" variant="outline-primary" size="sm" onClick={() => searchRequest(0)}>Search</Button>&nbsp;
                                                {
                                                    rightInwardList.add === "1" ? <>
                                                        <Button variant="outline-primary" size="sm" onClick={() => addNewInward()}>New</Button>&nbsp;
                                                    </> : null
                                                }
                                                &nbsp;
                                                {(srchStatus === 'RFA' && tpBankData.length > 0 && rightDownloadBankFile.edit === "1") &&
                                                    < Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => setShowDownloadModal(true)}>Download Bank File</Button>
                                                }
                                                &nbsp;
                                                <input
                                                    type="checkbox"
                                                    checked={srchAutoRefresh}
                                                    onChange={handleAutoRefresh}
                                                />
                                                &nbsp;Auto Refresh (30 seconds)&nbsp;
                                            </Col>
                                        </Row>
                                        <Row><Col>&nbsp;</Col></Row>
                                        <Row>
                                            <Col>
                                                <Table bordered >
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                {srchStatus === "RFA" && rightDownloadBankFile.edit === "1" &&
                                                                    <Form.Check
                                                                        type='checkbox'
                                                                        label=""
                                                                        checked={allChecked}
                                                                        onChange={handleSelectAll}
                                                                    />
                                                                }

                                                            </th>
                                                            <th>Sr. No.</th>
                                                            <th>Status</th>
                                                            <th>User</th>
                                                            <th>Action</th>
                                                            <th>Issuer</th>
                                                            <th>Branch</th>
                                                            <th>Agent</th>
                                                            <th>Date</th>
                                                            <th>ISD</th>
                                                            <th>Quantity</th>
                                                            {srchStatus === "RFA" &&
                                                                <th>Amount</th>}
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="searchList">
                                                        {tranListData.map((res, index) =>
                                                            <>
                                                                <tr key={index}>
                                                                    <td>
                                                                        {srchStatus === "RFA" && rightDownloadBankFile.edit === "1" &&
                                                                            <Form.Check
                                                                                type="checkbox"
                                                                                checked={res.ischecked === '1'}
                                                                                onChange={(e) => updateCheck(index, e, "ischecked")}
                                                                            />
                                                                        }
                                                                    </td>
                                                                    <td>{res.reqi_srno}</td>
                                                                    <td className={(res.reqi_status === "REP" || res.reqi_status === "REF" || res.reqi_status === "NTT" || res.reqi_status === "RTT") ? "bg-success text-white" : ""}>{sessionStorage.userSrno === "1" ? res.reqi_status + " : " : ""}{getStatusNameByRow(res)}</td>
                                                                    <td>{res.um_username}</td>
                                                                    <td>{getActionName(res.reqi_branchconfirmstatus)}</td>
                                                                    <td
                                                                        className={res.reqi_issuer * 1 === 9 ? 'bg-danger text-white' : (res.reqi_issuer * 1 === 10 ? "bg-warning text-dark" : (res.reqi_issuer * 1 === 5 ? "bg-success text-white" : ""))}
                                                                    >{res.issuer_name}</td>
                                                                    <td>{res.reqi_brnno} : {res.reqi_branchname} </td>
                                                                    <td>
                                                                        {
                                                                            res.reqi_agentno === "0" ? <>
                                                                            </> : <>
                                                                                {res.reqi_agentno} : {res.reqi_agentname}
                                                                            </>
                                                                        }
                                                                    </td>
                                                                    <td>{res.reqi_datedmy}</td>
                                                                    <td>{res.reqi_isd}</td>
                                                                    <td>{srchStatus === "ACQ" ? "" : res.reqi_quantity}</td>
                                                                    {srchStatus === "RFA" &&
                                                                        <td>{res.reqi_clientrefundinr}</td>}
                                                                    <td>
                                                                        <span className="handCursor colorThemeBlue"
                                                                            title="View Details"
                                                                            onClick={(e) => showInwardDetails(res.reqi_srno)}
                                                                        >
                                                                            <FontAwesomeIcon icon={faEye} />
                                                                        </span>&nbsp;&nbsp;
                                                                        {
                                                                            //  && (res.reqi_branchreprocessquantity - res.reqi_quantity) * 1 > 0
                                                                            rightInwardCoverFinal.add === "1" ? <>
                                                                                <span className={res.reqi_coverfinal === "1" ? "colorThemeBlue" : "colorThemeRed"}
                                                                                    title="Add Cover"
                                                                                    onClick={(e) => showCoverWindow(res.reqi_srno)}
                                                                                >
                                                                                    <span className="handCursor"  >
                                                                                        <FontAwesomeIcon icon={faRupeeSign} />
                                                                                    </span>&nbsp;&nbsp;
                                                                                </span>
                                                                            </> : null
                                                                        }
                                                                        {
                                                                            // && (res.reqi_branchconfirmstatus === "PBT" )
                                                                            rightInwardCreditReceived.add === "1" && res.reqi_coverfinal === "1" ? <>
                                                                                <span className={res.reqi_paymentcredited === "1" ? "colorThemeBlue" : "colorThemeRed"}
                                                                                    title="Add Credit"
                                                                                    onClick={(e) => showInwardCreditWindow(res.reqi_srno)}
                                                                                >
                                                                                    <span className="handCursor"  >
                                                                                        <FontAwesomeIcon icon={faMoneyCheck} />
                                                                                    </span>&nbsp;&nbsp;
                                                                                </span>
                                                                            </> : null
                                                                        }
                                                                    </td>
                                                                </tr>
                                                                {
                                                                    srchStatus === "ACQ" && rightInwardCoverFinal.add * 1 === 1 && (res.reqi_branchconfirmstatus === "PBT" || (res.reqi_branchconfirmstatus === "PRE" && (res.reqi_branchreprocessquantity * 1 - res.reqi_quantity * 1) > 0)) ? <>
                                                                        <tr>
                                                                            <td colspan="12" align="right" >
                                                                                {
                                                                                    res.reqi_branchconfirmstatus === "PBT" ? <>
                                                                                        <span>Inward : {res.reqi_quantity} </span>&nbsp;
                                                                                    </> : <>
                                                                                        <span>Inward : {res.reqi_quantity} Reprocess : {res.reqi_branchreprocessquantity}</span>&nbsp;<span className="BigFont">Balance :<b>{(res.reqi_branchreprocessquantity) - (res.reqi_quantity)}</b> </span>&nbsp;
                                                                                    </>
                                                                                }

                                                                                <input type="text" className="QuickDeal" id={"DealId" + res.reqi_srno} placeholder="Deal Id" maxLength={50} autoComplete="off" ></input>
                                                                                &nbsp;
                                                                                <input type="text" className="QuickDeal" id={"DealRate" + res.reqi_srno} placeholder="Deal Rate"
                                                                                    maxLength={20} autoComplete="off"
                                                                                ></input>&nbsp;
                                                                                <select className="QuickDeal" id={"DealTenure" + res.reqi_srno} style={{ width: "150px" }} >
                                                                                    <option value="TOM">TOM</option>
                                                                                    <option value="CASH">CASH</option>
                                                                                    <option value="SPOT">SPOT</option>
                                                                                </select>
                                                                                &nbsp;
                                                                                <Button onClick={() => quickCoverFinal(res.reqi_srno, res.reqi_branchconfirmstatus, res.reqi_quantity, res.reqi_branchreprocessquantity)}>Final Cover</Button>
                                                                            </td>
                                                                        </tr>
                                                                    </> : null
                                                                }

                                                                {
                                                                    srchStatus === "PFC" ? <>
                                                                        <tr>
                                                                            <td align="right" colspan="12">
                                                                                Value Date : &nbsp;{res.reqi_covervaluedatedmy}&nbsp;Approx Amount : {res.reqi_covertotalinr}
                                                                            </td>
                                                                        </tr>
                                                                    </> : <>
                                                                        {
                                                                            res.reqi_remittername.trim() !== "" || res.reqi_subjectline.trim() !== "" || res.reqi_inwardrefno.trim() !== "" ? <>
                                                                                <tr>
                                                                                    <td colspan="12" >
                                                                                        {res.reqi_inwardrefno}&nbsp;{res.reqi_zenithrefno}&nbsp;{res.reqi_remittername}&nbsp;{res.reqi_agentname}:{res.reqi_otheragentname}&nbsp;{res.reqi_subjectline}
                                                                                    </td>
                                                                                </tr>
                                                                            </> : null
                                                                        }
                                                                    </>
                                                                }
                                                                {
                                                                    srchStatus === "RFA" ? <>
                                                                        <tr>
                                                                            <td colspan="12">
                                                                                {res.zmapprove_logtime}&nbsp;{res.reqi_clientbankacctno}&nbsp;{res.reqi_clientbankacctifsc}&nbsp;{res.mbl_name}&nbsp;{res.bank_name}
                                                                            </td>
                                                                        </tr>
                                                                    </> : null
                                                                }
                                                                {
                                                                    srchStatus === "REF" ? <>
                                                                        <tr>
                                                                            <td colspan="12">
                                                                                Reference No : {res.reqi_refundedbankref}&nbsp;
                                                                            </td>
                                                                        </tr></> : null
                                                                }
                                                            </>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                        <Row>{refreshCounter}</Row>
                                    </Container>

                                </> : null
                        }
                        {
                            showCvr && rightInwardCoverFinal.query === "1" ? <>
                                <InwardCover srno={modalRef} callInProgress={backToList} ></InwardCover>
                            </> : null
                        }
                        {
                            showInwardCredit && rightInwardCreditReceived.add === "1" ? <>
                                <InwardCreditReceived srno={modalRef} callInProgress={backToList} ></InwardCreditReceived>
                            </> : null
                        }
                        <div>
                            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                                {msgText}
                            </Dialog>
                        </div>
                        <Modal
                            show={showDocument}
                            onHide={() => setShowDocument(false)}
                            size="xl"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    {documentDescToView + " : " + documentNameToView}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                                {
                                    /*
                                    type="image/png" type="application/pdf"
                                    width="100%" height="100%"
                                    
                                    <object data={documentToView} type={documentTypeToView} class="internal">
                 
                                    </object>
                                    */
                                }
                            </Modal.Body>
                        </Modal>
                        <Modal
                            show={showFetchTransaction}
                            onHide={() => setShowFetchTransaction(false)}
                            size="xl"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title >
                                    Backoffice Transaction Details:
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col>
                                        <b>Order No : {backOfficeData.orderNo} </b>
                                    </Col>
                                    <Col>
                                        <b>Order Date : {ftOrderDate.split('-').reverse().join('/')}</b>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>
                                            ISD : {backOfficeData.isd}
                                        </b>
                                    </Col>
                                    <Col>
                                        <b>Quantity : {backOfficeData.isdQty}</b>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>Remitter : {backOfficeData.clientNm} </b>
                                    </Col>
                                    <Col>
                                        <b>
                                            Beneficiary : {backOfficeData.beniName}
                                        </b>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>Refund To : {backOfficeData.refundToName}</b>
                                    </Col>
                                    <Col>
                                        <b>Refund Account : {backOfficeData.refundToAccount} ({backOfficeData.refundToIfsc}) </b>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>Rate : {backOfficeData.saleRate}</b>
                                    </Col>
                                    <Col>
                                        <b>Inward INR : {(1 * backOfficeData.saleRate * 1 * backOfficeData.isdQty).toFixed(2)}</b>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>Service Charges : {ftCalcSrvChrg}</b>
                                    </Col>
                                    <Col>
                                        <b>GST : {ftCalcGst} </b>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <b>Round Off : {ftCalcRoundOff}</b>
                                    </Col>
                                    <Col>
                                        <b>Net Refund : {backOfficeData.totAmnt}</b>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Button variant="outline-success" size="sm" onClick={() => updateCharges()}>Update</Button>&nbsp;
                                    </Col>
                                </Row>
                            </Modal.Body>
                        </Modal>
                    </>
            }
            <Modal
                show={showRefundConfirmModal}
                onHide={() => setShowRefundConfirmModal(false)}

                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Cover Request Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>
                        <Row>
                            <Col>
                                Quantity : {reqQuantity}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Client Rate :  {reqClientRate}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                CGST :  {reqCgstInr}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                SGST :  {reqSgstInr}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                IGST :  {reqIgstInr}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                UGST :  {reqUgstInr}
                            </Col>
                        </Row>
                    </h3>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => saveDataRefundRequest()} >Submit</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => setShowRefundConfirmModal(false)} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal size='lg' show={showDownloadModal} onHide={() => setShowDownloadModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Bank Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Form.Group>
                            <Form.Label>Refund Bank</Form.Label>
                            <Form.Select
                                value={reqPayBankCode}
                                onChange={(e) => setReqBankCode(e.target.value)}  >
                                {ddReqPayBankOptions.map((res) =>
                                    <option key={res.value} value={res.value}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDownloadModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={downloadBankFile}>
                        Download Bank Files
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default InwardList;